/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} ActiveInputs */
/** @typedef {{}} Active_SubInputs */
/** @typedef {{}} ActivityInputs */
/** @typedef {{}} Activity_EmptyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Activity_Empty_PersonInputs */
/** @typedef {{}} Add_ChoreInputs */
/** @typedef {{}} Add_Home_FirstInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ago_DaysInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ago_HoursInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ago_MinutesInputs */
/** @typedef {{}} Ago_NowInputs */
/** @typedef {{}} AnyoneInputs */
/** @typedef {{}} App_TaglineInputs */
/** @typedef {{}} BackInputs */
/** @typedef {{}} Badge_Bonus10_DescInputs */
/** @typedef {{}} Badge_Bonus10_NameInputs */
/** @typedef {{}} Badge_Bonus_DescInputs */
/** @typedef {{}} Badge_Bonus_NameInputs */
/** @typedef {{}} Badge_Done10_DescInputs */
/** @typedef {{}} Badge_Done10_NameInputs */
/** @typedef {{}} Badge_Done250_DescInputs */
/** @typedef {{}} Badge_Done250_NameInputs */
/** @typedef {{}} Badge_Done50_DescInputs */
/** @typedef {{}} Badge_Done50_NameInputs */
/** @typedef {{}} Badge_Early_DescInputs */
/** @typedef {{}} Badge_Early_NameInputs */
/** @typedef {{}} Badge_First_DescInputs */
/** @typedef {{}} Badge_First_NameInputs */
/** @typedef {{}} Badge_Freeze_DescInputs */
/** @typedef {{}} Badge_Freeze_NameInputs */
/** @typedef {{}} Badge_Level10_DescInputs */
/** @typedef {{}} Badge_Level10_NameInputs */
/** @typedef {{}} Badge_Level5_DescInputs */
/** @typedef {{}} Badge_Level5_NameInputs */
/** @typedef {{}} Badge_Night_DescInputs */
/** @typedef {{}} Badge_Night_NameInputs */
/** @typedef {{}} Badge_Rare_DescInputs */
/** @typedef {{}} Badge_Rare_NameInputs */
/** @typedef {{}} Badge_Rescue_DescInputs */
/** @typedef {{}} Badge_Rescue_NameInputs */
/** @typedef {{}} Badge_Room_DescInputs */
/** @typedef {{}} Badge_Room_NameInputs */
/** @typedef {{}} Badge_Stickers10_DescInputs */
/** @typedef {{}} Badge_Stickers10_NameInputs */
/** @typedef {{}} Badge_Streak100_DescInputs */
/** @typedef {{}} Badge_Streak100_NameInputs */
/** @typedef {{}} Badge_Streak30_DescInputs */
/** @typedef {{}} Badge_Streak30_NameInputs */
/** @typedef {{}} Badge_Streak3_DescInputs */
/** @typedef {{}} Badge_Streak3_NameInputs */
/** @typedef {{}} Badge_Streak7_DescInputs */
/** @typedef {{}} Badge_Streak7_NameInputs */
/** @typedef {{}} Badge_Team_DescInputs */
/** @typedef {{}} Badge_Team_NameInputs */
/** @typedef {{}} BadgesInputs */
/** @typedef {{}} Big_JobInputs */
/** @typedef {{}} Big_JobsInputs */
/** @typedef {{}} BonusInputs */
/** @typedef {{}} Break_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Break_DaysInputs */
/** @typedef {{}} Break_EndInputs */
/** @typedef {{ date: NonNullable<unknown> }} Break_EndsInputs */
/** @typedef {{}} Break_How_LongInputs */
/** @typedef {{}} Break_ReassureInputs */
/** @typedef {{}} Break_SickInputs */
/** @typedef {{}} Break_Sick_TitleInputs */
/** @typedef {{}} Break_TitleInputs */
/** @typedef {{}} Break_TodayInputs */
/** @typedef {{}} Break_Two_WeeksInputs */
/** @typedef {{ date: NonNullable<unknown> }} Break_UntilInputs */
/** @typedef {{}} Break_VacationInputs */
/** @typedef {{}} Break_WeekInputs */
/** @typedef {{}} Break_WeekendInputs */
/** @typedef {{}} BuyInputs */
/** @typedef {{ price: NonNullable<unknown>, pet: NonNullable<unknown> }} Buy_Confirm_BodyInputs */
/** @typedef {{ item: NonNullable<unknown> }} Buy_Confirm_TitleInputs */
/** @typedef {{}} Calendar_BreakInputs */
/** @typedef {{}} Calendar_CopiedInputs */
/** @typedef {{}} Calendar_CopyInputs */
/** @typedef {{}} Calendar_CreateInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Calendar_DoneInputs */
/** @typedef {{}} Calendar_GoogleInputs */
/** @typedef {{}} Calendar_GuestsInputs */
/** @typedef {{}} Calendar_IntroInputs */
/** @typedef {{}} Calendar_LinkedInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Calendar_MinutesInputs */
/** @typedef {{ household: NonNullable<unknown> }} Calendar_NameInputs */
/** @typedef {{}} Calendar_OpenInputs */
/** @typedef {{}} Calendar_PrivateInputs */
/** @typedef {{}} Calendar_ResetInputs */
/** @typedef {{}} Calendar_Row_OnInputs */
/** @typedef {{}} Calendar_Row_SubInputs */
/** @typedef {{}} Calendar_StopInputs */
/** @typedef {{}} Calendar_TitleInputs */
/** @typedef {{}} Calendar_YoursInputs */
/** @typedef {{}} CancelInputs */
/** @typedef {{}} Chore_AddedInputs */
/** @typedef {{}} Chore_AquariumInputs */
/** @typedef {{}} Chore_BalconyInputs */
/** @typedef {{}} Chore_Bath_MatsInputs */
/** @typedef {{}} Chore_Bathroom_FloorInputs */
/** @typedef {{}} Chore_Bathroom_SinkInputs */
/** @typedef {{}} Chore_BathtubInputs */
/** @typedef {{}} Chore_BinInputs */
/** @typedef {{}} Chore_Bird_CageInputs */
/** @typedef {{}} Chore_CabinetsInputs */
/** @typedef {{}} Chore_CageInputs */
/** @typedef {{}} Chore_CurtainsInputs */
/** @typedef {{}} Chore_Descale_KettleInputs */
/** @typedef {{}} Chore_DeskInputs */
/** @typedef {{}} Chore_Dining_TableInputs */
/** @typedef {{}} Chore_Dishwasher_FilterInputs */
/** @typedef {{}} Chore_DoorsInputs */
/** @typedef {{}} Chore_DrawerInputs */
/** @typedef {{}} Chore_Dryer_LintInputs */
/** @typedef {{}} Chore_DustInputs */
/** @typedef {{}} Chore_FansInputs */
/** @typedef {{}} Chore_FreezerInputs */
/** @typedef {{}} Chore_Fridge_ClearoutInputs */
/** @typedef {{}} Chore_Fridge_DeepInputs */
/** @typedef {{}} Chore_GarageInputs */
/** @typedef {{}} Chore_Garden_FurnitureInputs */
/** @typedef {{}} Chore_GroutInputs */
/** @typedef {{}} Chore_Guest_RoomInputs */
/** @typedef {{}} Chore_GuttersInputs */
/** @typedef {{}} Chore_HallwayInputs */
/** @typedef {{}} Chore_Hood_FilterInputs */
/** @typedef {{}} Chore_Kitchen_SinkInputs */
/** @typedef {{}} Chore_Laundry_RoomInputs */
/** @typedef {{}} Chore_Litter_BoxInputs */
/** @typedef {{}} Chore_MattressInputs */
/** @typedef {{}} Chore_MicrowaveInputs */
/** @typedef {{}} Chore_Mop_KitchenInputs */
/** @typedef {{ n: NonNullable<unknown>, total: NonNullable<unknown> }} Chore_N_OfInputs */
/** @typedef {{}} Chore_Name_LabelInputs */
/** @typedef {{}} Chore_NightstandInputs */
/** @typedef {{}} Chore_OvenInputs */
/** @typedef {{}} Chore_PantryInputs */
/** @typedef {{}} Chore_Pet_BedInputs */
/** @typedef {{}} Chore_Pet_BowlsInputs */
/** @typedef {{}} Chore_Pet_HairInputs */
/** @typedef {{}} Chore_Pet_ToysInputs */
/** @typedef {{}} Chore_PillowsInputs */
/** @typedef {{}} Chore_PlaceholderInputs */
/** @typedef {{}} Chore_Plant_LeavesInputs */
/** @typedef {{}} Chore_PlantsInputs */
/** @typedef {{}} Chore_RadiatorsInputs */
/** @typedef {{}} Chore_RugsInputs */
/** @typedef {{}} Chore_ScreensInputs */
/** @typedef {{}} Chore_SheetsInputs */
/** @typedef {{}} Chore_ShowerInputs */
/** @typedef {{}} Chore_Shower_CurtainInputs */
/** @typedef {{}} Chore_ShowerheadInputs */
/** @typedef {{}} Chore_SkirtingInputs */
/** @typedef {{}} Chore_Smoke_AlarmsInputs */
/** @typedef {{}} Chore_SofaInputs */
/** @typedef {{}} Chore_StairsInputs */
/** @typedef {{}} Chore_StovetopInputs */
/** @typedef {{}} Chore_SwitchesInputs */
/** @typedef {{}} Chore_ToiletInputs */
/** @typedef {{}} Chore_Toilet_BasinInputs */
/** @typedef {{}} Chore_Under_BedInputs */
/** @typedef {{}} Chore_Vacuum_FilterInputs */
/** @typedef {{}} Chore_Vacuum_LivingInputs */
/** @typedef {{}} Chore_WardrobeInputs */
/** @typedef {{}} Chore_Washing_MachineInputs */
/** @typedef {{}} Chore_WeedingInputs */
/** @typedef {{}} Chore_Windows_InsideInputs */
/** @typedef {{}} Chore_Windows_OutsideInputs */
/** @typedef {{ count: NonNullable<unknown> }} Chores_CountInputs */
/** @typedef {{ count: NonNullable<unknown> }} Chores_OnInputs */
/** @typedef {{}} CleanlinessInputs */
/** @typedef {{}} CloseInputs */
/** @typedef {{}} Coins_LabelInputs */
/** @typedef {{ count: NonNullable<unknown> }} Coins_NInputs */
/** @typedef {{}} ColourInputs */
/** @typedef {{}} CompanionInputs */
/** @typedef {{}} Confirm_Delete_ChoreInputs */
/** @typedef {{ household: NonNullable<unknown> }} Confirm_LeaveInputs */
/** @typedef {{}} Confirm_Sign_OutInputs */
/** @typedef {{}} _ContinueInputs */
/** @typedef {{}} Copy_CodeInputs */
/** @typedef {{}} Crash_BodyInputs */
/** @typedef {{}} Crash_TitleInputs */
/** @typedef {{}} Create_HouseholdInputs */
/** @typedef {{}} Daily_TimeInputs */
/** @typedef {{}} Daily_Time_SubInputs */
/** @typedef {{ count: NonNullable<unknown> }} Days_OverdueInputs */
/** @typedef {{}} _DeleteInputs */
/** @typedef {{}} Delete_ChoreInputs */
/** @typedef {{ os: NonNullable<unknown> }} Device_AppInputs */
/** @typedef {{}} Device_CodeInputs */
/** @typedef {{}} Device_GenericInputs */
/** @typedef {{ browser: NonNullable<unknown>, os: NonNullable<unknown> }} Device_NameInputs */
/** @typedef {{}} DoneInputs */
/** @typedef {{}} Done_ButtonInputs */
/** @typedef {{}} Done_For_TodayInputs */
/** @typedef {{}} Dry_DayInputs */
/** @typedef {{ count: NonNullable<unknown> }} Due_In_DaysInputs */
/** @typedef {{}} Due_TodayInputs */
/** @typedef {{}} Due_TomorrowInputs */
/** @typedef {{ hours: NonNullable<unknown> }} Duration_HInputs */
/** @typedef {{ hours: NonNullable<unknown>, minutes: NonNullable<unknown> }} Duration_H_MInputs */
/** @typedef {{}} Easier_OneInputs */
/** @typedef {{}} Edit_ChoreInputs */
/** @typedef {{}} EffortInputs */
/** @typedef {{}} Effort_1Inputs */
/** @typedef {{}} Effort_2Inputs */
/** @typedef {{}} Effort_3Inputs */
/** @typedef {{}} Err_Already_DoneInputs */
/** @typedef {{}} Err_Assignment_Not_FoundInputs */
/** @typedef {{}} Err_AvatarInputs */
/** @typedef {{}} Err_Bonus_Needs_DailyInputs */
/** @typedef {{}} Err_Bonus_NoneInputs */
/** @typedef {{}} Err_Bonus_PendingInputs */
/** @typedef {{}} Err_Chore_NameInputs */
/** @typedef {{}} Err_Chore_Not_FoundInputs */
/** @typedef {{}} Err_CodeInputs */
/** @typedef {{}} Err_ForbiddenInputs */
/** @typedef {{}} Err_Freezes_FullInputs */
/** @typedef {{}} Err_FreqInputs */
/** @typedef {{}} Err_GenericInputs */
/** @typedef {{}} Err_Guests_DateInputs */
/** @typedef {{}} Err_High_Five_SelfInputs */
/** @typedef {{}} Err_Household_NameInputs */
/** @typedef {{ count: NonNullable<unknown> }} Err_Household_Too_SmallInputs */
/** @typedef {{}} Err_InvalidInputs */
/** @typedef {{}} Err_Invite_CodeInputs */
/** @typedef {{}} Err_Invite_Not_FoundInputs */
/** @typedef {{}} Err_Item_OwnedInputs */
/** @typedef {{}} Err_Link_InvalidInputs */
/** @typedef {{}} Err_Member_Not_FoundInputs */
/** @typedef {{}} Err_No_ConnectionInputs */
/** @typedef {{}} Err_No_Swap_OptionInputs */
/** @typedef {{}} Err_Not_Enough_CoinsInputs */
/** @typedef {{}} Err_Not_FoundInputs */
/** @typedef {{}} Err_Nothing_To_SwapInputs */
/** @typedef {{}} Err_OfflineInputs */
/** @typedef {{}} Err_OwnerInputs */
/** @typedef {{}} Err_Pause_PastInputs */
/** @typedef {{}} Err_Pause_Too_LongInputs */
/** @typedef {{}} Err_People_MaxInputs */
/** @typedef {{}} Err_People_MinInputs */
/** @typedef {{}} Err_Pet_NameInputs */
/** @typedef {{}} Err_Photo_InvalidInputs */
/** @typedef {{}} Err_Photo_Too_BigInputs */
/** @typedef {{}} Err_Places_UnavailableInputs */
/** @typedef {{}} Err_Project_Last_StepInputs */
/** @typedef {{}} Err_Project_NameInputs */
/** @typedef {{}} Err_Project_StepsInputs */
/** @typedef {{}} Err_Push_SubscriptionInputs */
/** @typedef {{}} Err_Rate_LimitedInputs */
/** @typedef {{}} Err_RoomInputs */
/** @typedef {{}} Err_Schedule_EmptyInputs */
/** @typedef {{}} Err_ServerInputs */
/** @typedef {{}} Err_Sign_InInputs */
/** @typedef {{}} Err_Sign_In_AgainInputs */
/** @typedef {{}} Err_Step_NameInputs */
/** @typedef {{}} Err_Supplies_FullInputs */
/** @typedef {{}} Err_Supply_NameInputs */
/** @typedef {{}} Err_Swap_UsedInputs */
/** @typedef {{}} Err_Time_FormatInputs */
/** @typedef {{}} Err_TimeoutInputs */
/** @typedef {{}} Err_Timer_MinutesInputs */
/** @typedef {{}} Err_Timers_FullInputs */
/** @typedef {{}} Err_Too_LargeInputs */
/** @typedef {{}} Err_Too_LongInputs */
/** @typedef {{}} Err_Trade_GoneInputs */
/** @typedef {{}} Err_Trade_NothingInputs */
/** @typedef {{}} Err_Trade_OwnedInputs */
/** @typedef {{}} Err_Treat_NameInputs */
/** @typedef {{}} Err_Treat_PriceInputs */
/** @typedef {{}} Err_Treats_FullInputs */
/** @typedef {{}} Err_TzInputs */
/** @typedef {{}} Err_Your_NameInputs */
/** @typedef {{}} Every_How_Many_DaysInputs */
/** @typedef {{}} EveryoneInputs */
/** @typedef {{}} ExpiredInputs */
/** @typedef {{ time: NonNullable<unknown> }} Expires_InInputs */
/** @typedef {{}} Fair_ShareInputs */
/** @typedef {{}} Fair_Share_EmptyInputs */
/** @typedef {{ days: NonNullable<unknown> }} Fair_Share_HintInputs */
/** @typedef {{}} First_Badge_HintInputs */
/** @typedef {{ sticker: NonNullable<unknown> }} Found_StickerInputs */
/** @typedef {{}} Freeze_BoughtInputs */
/** @typedef {{ price: NonNullable<unknown> }} Freeze_Confirm_BodyInputs */
/** @typedef {{}} Freeze_Confirm_TitleInputs */
/** @typedef {{}} Freeze_CoveredInputs */
/** @typedef {{}} Freeze_EarnedInputs */
/** @typedef {{}} Freeze_Earned_SubInputs */
/** @typedef {{}} Freeze_FullInputs */
/** @typedef {{}} Freeze_ItemInputs */
/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Freeze_Item_SubInputs */
/** @typedef {{ count: NonNullable<unknown> }} Freezes_CountInputs */
/** @typedef {{}} Freq_2monthsInputs */
/** @typedef {{}} Freq_2weeksInputs */
/** @typedef {{}} Freq_3monthsInputs */
/** @typedef {{}} Freq_CustomInputs */
/** @typedef {{}} Freq_DailyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Freq_Every_DaysInputs */
/** @typedef {{ count: NonNullable<unknown> }} Freq_Every_WeeksInputs */
/** @typedef {{}} Freq_MonthlyInputs */
/** @typedef {{}} Freq_Twice_YearInputs */
/** @typedef {{}} Freq_WeeklyInputs */
/** @typedef {{}} Freq_YearlyInputs */
/** @typedef {{}} Fully_GrownInputs */
/** @typedef {{}} Furniture_AquariumInputs */
/** @typedef {{}} Furniture_BookcaseInputs */
/** @typedef {{}} Furniture_ClockInputs */
/** @typedef {{}} Furniture_CushionInputs */
/** @typedef {{}} Furniture_Disco_BallInputs */
/** @typedef {{}} Furniture_DotsInputs */
/** @typedef {{}} Furniture_Fairy_LightsInputs */
/** @typedef {{}} Furniture_Floor_LampInputs */
/** @typedef {{}} Furniture_PaintingInputs */
/** @typedef {{ pet: NonNullable<unknown>, item: NonNullable<unknown> }} Furniture_PermissionInputs */
/** @typedef {{}} Furniture_PlantInputs */
/** @typedef {{}} Furniture_RugInputs */
/** @typedef {{}} Furniture_ShelfInputs */
/** @typedef {{}} Furniture_StripesInputs */
/** @typedef {{}} Furniture_WindowInputs */
/** @typedef {{ date: NonNullable<unknown> }} Guests_BannerInputs */
/** @typedef {{}} Guests_ClearInputs */
/** @typedef {{}} Guests_IntroInputs */
/** @typedef {{ date: NonNullable<unknown> }} Guests_OnInputs */
/** @typedef {{}} Guests_PickInputs */
/** @typedef {{}} Guests_RowInputs */
/** @typedef {{}} Guests_Row_SubInputs */
/** @typedef {{}} Guests_TitleInputs */
/** @typedef {{}} Guests_TomorrowInputs */
/** @typedef {{ count: NonNullable<unknown> }} Hide_InactiveInputs */
/** @typedef {{}} High_FiveInputs */
/** @typedef {{}} High_FivedInputs */
/** @typedef {{}} HistoryInputs */
/** @typedef {{}} History_EmptyInputs */
/** @typedef {{}} Home_IntroInputs */
/** @typedef {{}} Home_Pet_BirdInputs */
/** @typedef {{}} Home_Pet_CatInputs */
/** @typedef {{}} Home_Pet_DogInputs */
/** @typedef {{}} Home_Pet_FishInputs */
/** @typedef {{}} Home_Pet_Small_PetInputs */
/** @typedef {{}} Home_SavedInputs */
/** @typedef {{}} Home_Space_BalconyInputs */
/** @typedef {{}} Home_Space_DiningInputs */
/** @typedef {{}} Home_Space_GarageInputs */
/** @typedef {{}} Home_Space_GardenInputs */
/** @typedef {{}} Home_Space_Guest_RoomInputs */
/** @typedef {{}} Home_Space_LaundryInputs */
/** @typedef {{}} Home_Space_OfficeInputs */
/** @typedef {{}} Home_Space_StairsInputs */
/** @typedef {{}} Home_Thing_BathtubInputs */
/** @typedef {{}} Home_Thing_DishwasherInputs */
/** @typedef {{}} Home_Thing_DryerInputs */
/** @typedef {{}} Home_Thing_PlantsInputs */
/** @typedef {{}} Home_TitleInputs */
/** @typedef {{}} Home_Type_ApartmentInputs */
/** @typedef {{}} Home_Type_HouseInputs */
/** @typedef {{}} HouseholdInputs */
/** @typedef {{}} Household_NameInputs */
/** @typedef {{}} Household_Name_PlaceholderInputs */
/** @typedef {{ months: NonNullable<unknown> }} In_SeasonInputs */
/** @typedef {{}} Install_BodyInputs */
/** @typedef {{}} Install_ButtonInputs */
/** @typedef {{}} Install_Done_BodyInputs */
/** @typedef {{}} Install_Done_TitleInputs */
/** @typedef {{}} Install_Invite_NoteInputs */
/** @typedef {{}} Install_Ios_1Inputs */
/** @typedef {{}} Install_Ios_2Inputs */
/** @typedef {{}} Install_OpenInputs */
/** @typedef {{}} Install_Other_1Inputs */
/** @typedef {{}} Install_Other_2Inputs */
/** @typedef {{}} Install_SkipInputs */
/** @typedef {{}} Install_TitleInputs */
/** @typedef {{}} Invite_CodeInputs */
/** @typedef {{ code: NonNullable<unknown> }} Invite_Code_ToastInputs */
/** @typedef {{}} Invite_CopiedInputs */
/** @typedef {{ household: NonNullable<unknown>, code: NonNullable<unknown> }} Invite_TextInputs */
/** @typedef {{}} Invite_WarningInputs */
/** @typedef {{}} Ios_Home_ScreenInputs */
/** @typedef {{}} Item_BeanieInputs */
/** @typedef {{}} Item_BikiniInputs */
/** @typedef {{}} Item_BowInputs */
/** @typedef {{}} Item_BroomInputs */
/** @typedef {{}} Item_FlowerInputs */
/** @typedef {{}} Item_GlassesInputs */
/** @typedef {{}} Item_Party_HatInputs */
/** @typedef {{ pet: NonNullable<unknown>, item: NonNullable<unknown> }} Item_PermissionInputs */
/** @typedef {{}} Item_ScarfInputs */
/** @typedef {{}} Item_SunglassesInputs */
/** @typedef {{}} Item_SunhatInputs */
/** @typedef {{}} JoinInputs */
/** @typedef {{}} Join_HouseholdInputs */
/** @typedef {{}} Keep_ListInputs */
/** @typedef {{}} LanguageInputs */
/** @typedef {{ language: NonNullable<unknown> }} Language_AutoInputs */
/** @typedef {{}} Last_7_DaysInputs */
/** @typedef {{ when: NonNullable<unknown> }} Last_ActiveInputs */
/** @typedef {{}} Last_DoneInputs */
/** @typedef {{ when: NonNullable<unknown>, name: NonNullable<unknown> }} Last_Done_ByInputs */
/** @typedef {{ count: NonNullable<unknown> }} Last_Done_DaysInputs */
/** @typedef {{}} Last_Done_TodayInputs */
/** @typedef {{}} Last_Done_YesterdayInputs */
/** @typedef {{}} Ld_Few_DaysInputs */
/** @typedef {{}} Ld_Few_MonthsInputs */
/** @typedef {{}} Ld_MonthInputs */
/** @typedef {{}} Ld_TodayInputs */
/** @typedef {{}} Ld_Two_WeeksInputs */
/** @typedef {{}} Ld_WeekInputs */
/** @typedef {{}} Ld_YearInputs */
/** @typedef {{}} Ld_YesterdayInputs */
/** @typedef {{}} Leave_HouseholdInputs */
/** @typedef {{ level: NonNullable<unknown> }} Level_NInputs */
/** @typedef {{}} Level_Title_0Inputs */
/** @typedef {{}} Level_Title_1Inputs */
/** @typedef {{}} Level_Title_10Inputs */
/** @typedef {{}} Level_Title_2Inputs */
/** @typedef {{}} Level_Title_3Inputs */
/** @typedef {{}} Level_Title_4Inputs */
/** @typedef {{}} Level_Title_5Inputs */
/** @typedef {{}} Level_Title_6Inputs */
/** @typedef {{}} Level_Title_7Inputs */
/** @typedef {{}} Level_Title_8Inputs */
/** @typedef {{}} Level_Title_9Inputs */
/** @typedef {{ title: NonNullable<unknown> }} Level_Up_SubInputs */
/** @typedef {{}} Link_DeviceInputs */
/** @typedef {{}} Link_Device_SubInputs */
/** @typedef {{}} Link_IntroInputs */
/** @typedef {{}} Link_Sheet_BodyInputs */
/** @typedef {{}} Link_TitleInputs */
/** @typedef {{}} Load_Error_TitleInputs */
/** @typedef {{}} LoadingInputs */
/** @typedef {{}} Mark_DoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Mark_X_DoneInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Minutes_ShortInputs */
/** @typedef {{}} Mood_GrumpyInputs */
/** @typedef {{}} Mood_HappyInputs */
/** @typedef {{}} Mood_MehInputs */
/** @typedef {{}} Mood_SadInputs */
/** @typedef {{}} Mood_ThrivingInputs */
/** @typedef {{}} NameInputs */
/** @typedef {{}} Never_MindInputs */
/** @typedef {{}} New_ChoreInputs */
/** @typedef {{}} New_CodeInputs */
/** @typedef {{}} New_HouseholdInputs */
/** @typedef {{}} New_RoomInputs */
/** @typedef {{}} Next_BadgesInputs */
/** @typedef {{}} No_Chores_AvailableInputs */
/** @typedef {{}} No_StreakInputs */
/** @typedef {{}} Not_Done_YetInputs */
/** @typedef {{}} Not_NowInputs */
/** @typedef {{}} Not_SureInputs */
/** @typedef {{}} NotesInputs */
/** @typedef {{}} Notes_HintInputs */
/** @typedef {{}} Notes_PlaceholderInputs */
/** @typedef {{}} Nothing_PickedInputs */
/** @typedef {{}} Notif_DailyInputs */
/** @typedef {{}} Notif_Daily_SubInputs */
/** @typedef {{}} Notif_RecapInputs */
/** @typedef {{}} Notif_Recap_SubInputs */
/** @typedef {{}} Notif_StreakInputs */
/** @typedef {{}} Notif_Streak_SubInputs */
/** @typedef {{}} Notif_TeamInputs */
/** @typedef {{}} Notif_Team_SubInputs */
/** @typedef {{}} NotificationsInputs */
/** @typedef {{}} OffInputs */
/** @typedef {{}} Off_This_DeviceInputs */
/** @typedef {{}} Offline_BannerInputs */
/** @typedef {{}} On_A_BreakInputs */
/** @typedef {{ count: NonNullable<unknown> }} Overdue_CountInputs */
/** @typedef {{}} PeopleInputs */
/** @typedef {{ count: NonNullable<unknown> }} People_CountInputs */
/** @typedef {{}} People_HintInputs */
/** @typedef {{}} People_QuestionInputs */
/** @typedef {{}} People_SubInputs */
/** @typedef {{ perDay: NonNullable<unknown> }} Per_Day_NeededInputs */
/** @typedef {{}} Pet_Bunny_Stage_0Inputs */
/** @typedef {{}} Pet_Bunny_Stage_1Inputs */
/** @typedef {{}} Pet_Bunny_Stage_2Inputs */
/** @typedef {{}} Pet_Bunny_Stage_3Inputs */
/** @typedef {{}} Pet_Bunny_Stage_4Inputs */
/** @typedef {{}} Pet_Bunny_Stage_5Inputs */
/** @typedef {{}} Pet_Cat_Stage_0Inputs */
/** @typedef {{}} Pet_Cat_Stage_1Inputs */
/** @typedef {{}} Pet_Cat_Stage_2Inputs */
/** @typedef {{}} Pet_Cat_Stage_3Inputs */
/** @typedef {{}} Pet_Cat_Stage_4Inputs */
/** @typedef {{}} Pet_Cat_Stage_5Inputs */
/** @typedef {{}} Pet_Chick_Stage_0Inputs */
/** @typedef {{}} Pet_Chick_Stage_1Inputs */
/** @typedef {{}} Pet_Chick_Stage_2Inputs */
/** @typedef {{}} Pet_Chick_Stage_3Inputs */
/** @typedef {{}} Pet_Chick_Stage_4Inputs */
/** @typedef {{}} Pet_Chick_Stage_5Inputs */
/** @typedef {{}} Pet_Fox_Stage_0Inputs */
/** @typedef {{}} Pet_Fox_Stage_1Inputs */
/** @typedef {{}} Pet_Fox_Stage_2Inputs */
/** @typedef {{}} Pet_Fox_Stage_3Inputs */
/** @typedef {{}} Pet_Fox_Stage_4Inputs */
/** @typedef {{}} Pet_Fox_Stage_5Inputs */
/** @typedef {{ name: NonNullable<unknown>, stage: NonNullable<unknown> }} Pet_Grew_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Pet_Grew_TitleInputs */
/** @typedef {{}} Pet_IntroInputs */
/** @typedef {{}} Pet_Kind_BunnyInputs */
/** @typedef {{}} Pet_Kind_CatInputs */
/** @typedef {{}} Pet_Kind_ChickInputs */
/** @typedef {{}} Pet_Kind_FoxInputs */
/** @typedef {{}} Pet_Kind_PupInputs */
/** @typedef {{}} Pet_Kind_SproutInputs */
/** @typedef {{}} Pet_Name_IdeasInputs */
/** @typedef {{}} Pet_Name_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Pet_OwnerInputs */
/** @typedef {{}} Pet_Pup_Stage_0Inputs */
/** @typedef {{}} Pet_Pup_Stage_1Inputs */
/** @typedef {{}} Pet_Pup_Stage_2Inputs */
/** @typedef {{}} Pet_Pup_Stage_3Inputs */
/** @typedef {{}} Pet_Pup_Stage_4Inputs */
/** @typedef {{}} Pet_Pup_Stage_5Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Pet_SavedInputs */
/** @typedef {{}} Pet_ShuffleInputs */
/** @typedef {{}} Pet_Sprout_Stage_0Inputs */
/** @typedef {{}} Pet_Sprout_Stage_1Inputs */
/** @typedef {{}} Pet_Sprout_Stage_2Inputs */
/** @typedef {{}} Pet_Sprout_Stage_3Inputs */
/** @typedef {{}} Pet_Sprout_Stage_4Inputs */
/** @typedef {{}} Pet_Sprout_Stage_5Inputs */
/** @typedef {{}} Pet_TitleInputs */
/** @typedef {{}} Pets_TitleInputs */
/** @typedef {{}} Photo_AddInputs */
/** @typedef {{}} Photo_LabelInputs */
/** @typedef {{}} Photo_Read_ErrorInputs */
/** @typedef {{}} Photo_RemoveInputs */
/** @typedef {{}} Photo_ReplaceInputs */
/** @typedef {{ count: NonNullable<unknown> }} Plus_BonusInputs */
/** @typedef {{ coins: NonNullable<unknown> }} Project_BonusInputs */
/** @typedef {{}} Project_CreateInputs */
/** @typedef {{}} Project_DeleteInputs */
/** @typedef {{}} Project_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Project_Delete_TitleInputs */
/** @typedef {{}} Project_DoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Project_FinishedInputs */
/** @typedef {{}} Project_IntroInputs */
/** @typedef {{}} Project_NameInputs */
/** @typedef {{}} Project_NewInputs */
/** @typedef {{}} Project_New_SubInputs */
/** @typedef {{}} Project_PaceInputs */
/** @typedef {{}} Project_Pace_1Inputs */
/** @typedef {{}} Project_Pace_3Inputs */
/** @typedef {{}} Project_Pace_7Inputs */
/** @typedef {{}} Project_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown>, done: NonNullable<unknown>, total: NonNullable<unknown> }} Project_ProgressInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Project_Row_SubInputs */
/** @typedef {{ project: NonNullable<unknown>, step: NonNullable<unknown>, total: NonNullable<unknown> }} Project_Step_OfInputs */
/** @typedef {{}} Project_StepsInputs */
/** @typedef {{}} Project_Steps_HintInputs */
/** @typedef {{}} Push_BlockedInputs */
/** @typedef {{}} Push_Blocked_HereInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Push_Daily_Body_StartInputs */
/** @typedef {{ minutes: NonNullable<unknown>, streak: NonNullable<unknown> }} Push_Daily_Body_StreakInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Push_Daily_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_High_Five_TitleInputs */
/** @typedef {{}} Push_Ios_FirstInputs */
/** @typedef {{}} Push_OnInputs */
/** @typedef {{ count: NonNullable<unknown> }} Push_On_DevicesInputs */
/** @typedef {{ mine: NonNullable<unknown>, total: NonNullable<unknown> }} Push_Recap_BodyInputs */
/** @typedef {{ mine: NonNullable<unknown> }} Push_Recap_Body_SoloInputs */
/** @typedef {{}} Push_Recap_TitleInputs */
/** @typedef {{}} Push_Streak_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Push_Streak_Body_FreezesInputs */
/** @typedef {{ streak: NonNullable<unknown> }} Push_Streak_TitleInputs */
/** @typedef {{ chore: NonNullable<unknown>, xp: NonNullable<unknown> }} Push_Team_BodyInputs */
/** @typedef {{ chore: NonNullable<unknown>, xp: NonNullable<unknown>, level: NonNullable<unknown> }} Push_Team_Body_LevelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Team_TitleInputs */
/** @typedef {{}} Push_Test_BodyInputs */
/** @typedef {{}} Push_Test_TitleInputs */
/** @typedef {{}} Push_Timer_Dishwasher_BodyInputs */
/** @typedef {{}} Push_Timer_Dishwasher_TitleInputs */
/** @typedef {{}} Push_Timer_Dryer_BodyInputs */
/** @typedef {{}} Push_Timer_Dryer_TitleInputs */
/** @typedef {{}} Push_Timer_Other_BodyInputs */
/** @typedef {{}} Push_Timer_Other_TitleInputs */
/** @typedef {{}} Push_Timer_Oven_BodyInputs */
/** @typedef {{}} Push_Timer_Oven_TitleInputs */
/** @typedef {{}} Push_Timer_Washer_BodyInputs */
/** @typedef {{}} Push_Timer_Washer_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Trade_AcceptedInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Push_Trade_Accepted_BodyInputs */
/** @typedef {{ give: NonNullable<unknown>, get: NonNullable<unknown> }} Push_Trade_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Trade_DeclinedInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Push_Trade_Declined_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Trade_TitleInputs */
/** @typedef {{}} Push_UnsupportedInputs */
/** @typedef {{}} Push_Unsupported_HereInputs */
/** @typedef {{}} Q_BathroomsInputs */
/** @typedef {{}} Q_Home_TypeInputs */
/** @typedef {{}} Q_PetsInputs */
/** @typedef {{}} Q_SpacesInputs */
/** @typedef {{}} Q_ThingsInputs */
/** @typedef {{}} Q_ToiletInputs */
/** @typedef {{}} Rarity_CommonInputs */
/** @typedef {{}} Rarity_EpicInputs */
/** @typedef {{}} Rarity_LegendaryInputs */
/** @typedef {{}} Rarity_RareInputs */
/** @typedef {{}} RebalanceInputs */
/** @typedef {{}} Rebalance_Confirm_TitleInputs */
/** @typedef {{ people: NonNullable<unknown> }} Rebalance_SubInputs */
/** @typedef {{}} Rebalance_TitleInputs */
/** @typedef {{}} Recap_Household_ChoresInputs */
/** @typedef {{ total: NonNullable<unknown>, mine: NonNullable<unknown> }} Recap_RowInputs */
/** @typedef {{ mine: NonNullable<unknown> }} Recap_Row_SoloInputs */
/** @typedef {{}} Recap_SubtitleInputs */
/** @typedef {{}} Recap_TitleInputs */
/** @typedef {{ count: NonNullable<unknown>, name: NonNullable<unknown> }} Recap_TopInputs */
/** @typedef {{}} Recap_Your_ChoresInputs */
/** @typedef {{}} ReloadInputs */
/** @typedef {{}} Remind_Me_AtInputs */
/** @typedef {{}} Reminder_BodyInputs */
/** @typedef {{}} Reminder_CtaInputs */
/** @typedef {{}} Reminder_Cta_SubInputs */
/** @typedef {{ time: NonNullable<unknown> }} Reminder_SetInputs */
/** @typedef {{}} Reminder_TitleInputs */
/** @typedef {{}} RemindersInputs */
/** @typedef {{}} RemoveInputs */
/** @typedef {{}} RepeatsInputs */
/** @typedef {{}} Rescue_BonusInputs */
/** @typedef {{}} Rest_Day_BodyInputs */
/** @typedef {{}} Rest_Day_TitleInputs */
/** @typedef {{}} Review_ChoresInputs */
/** @typedef {{}} Rhythm_ChangeInputs */
/** @typedef {{ chore: NonNullable<unknown>, freq: NonNullable<unknown> }} Rhythm_ChangedInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Rhythm_EarlyInputs */
/** @typedef {{}} Rhythm_KeepInputs */
/** @typedef {{}} Rhythm_LabelInputs */
/** @typedef {{ chore: NonNullable<unknown> }} Rhythm_LateInputs */
/** @typedef {{ new: NonNullable<unknown>, old: NonNullable<unknown> }} Rhythm_QuestionInputs */
/** @typedef {{ count: NonNullable<unknown>, chore: NonNullable<unknown> }} Rhythm_SkippedInputs */
/** @typedef {{}} RoomInputs */
/** @typedef {{}} Room_BathroomInputs */
/** @typedef {{}} Room_Bathroom_2Inputs */
/** @typedef {{}} Room_Bathroom_3Inputs */
/** @typedef {{}} Room_BedroomInputs */
/** @typedef {{ price: NonNullable<unknown>, pet: NonNullable<unknown> }} Room_Buy_BodyInputs */
/** @typedef {{}} Room_Dining_RoomInputs */
/** @typedef {{}} Room_GarageInputs */
/** @typedef {{}} Room_Guest_RoomInputs */
/** @typedef {{}} Room_HallwayInputs */
/** @typedef {{}} Room_IntroInputs */
/** @typedef {{}} Room_KitchenInputs */
/** @typedef {{}} Room_Laundry_RoomInputs */
/** @typedef {{}} Room_Living_RoomInputs */
/** @typedef {{}} Room_NameInputs */
/** @typedef {{}} Room_OfficeInputs */
/** @typedef {{}} Room_OutdoorsInputs */
/** @typedef {{}} Room_PetsInputs */
/** @typedef {{}} Room_PlacedInputs */
/** @typedef {{}} Room_PlaceholderInputs */
/** @typedef {{ count: NonNullable<unknown> }} Room_Row_SubInputs */
/** @typedef {{}} Room_Tap_To_PlaceInputs */
/** @typedef {{ pet: NonNullable<unknown> }} Room_TitleInputs */
/** @typedef {{}} Room_ToiletInputs */
/** @typedef {{}} Room_Whole_HouseInputs */
/** @typedef {{}} SaveInputs */
/** @typedef {{}} Save_DateInputs */
/** @typedef {{}} SavedInputs */
/** @typedef {{}} Schedule_HintInputs */
/** @typedef {{}} Schedule_SavedInputs */
/** @typedef {{}} SeasonalInputs */
/** @typedef {{}} Seasonal_SubInputs */
/** @typedef {{}} SectionsInputs */
/** @typedef {{ count: NonNullable<unknown> }} See_AllInputs */
/** @typedef {{}} Select_All_That_ApplyInputs */
/** @typedef {{}} SettingsInputs */
/** @typedef {{ people: NonNullable<unknown>, active: NonNullable<unknown>, perDay: NonNullable<unknown>, more: NonNullable<unknown> }} Setup_BodyInputs */
/** @typedef {{ active: NonNullable<unknown>, perDay: NonNullable<unknown>, more: NonNullable<unknown> }} Setup_Body_SoloInputs */
/** @typedef {{}} Setup_TitleInputs */
/** @typedef {{}} Share_InviteInputs */
/** @typedef {{ pet: NonNullable<unknown> }} Shop_IntroInputs */
/** @typedef {{}} Shop_OutfitsInputs */
/** @typedef {{}} Shop_OwnedInputs */
/** @typedef {{}} Shop_Row_SubInputs */
/** @typedef {{}} Shop_TitleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Shop_To_GoInputs */
/** @typedef {{}} Shop_WearingInputs */
/** @typedef {{}} Show_EarnedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Show_InactiveInputs */
/** @typedef {{}} Show_MoreInputs */
/** @typedef {{}} Sign_InInputs */
/** @typedef {{}} Sign_Out_DeviceInputs */
/** @typedef {{}} Sign_Out_HereInputs */
/** @typedef {{}} Signed_InInputs */
/** @typedef {{ name: NonNullable<unknown> }} Slip_BodyInputs */
/** @typedef {{}} Slip_OkInputs */
/** @typedef {{ pet: NonNullable<unknown> }} Slip_SignedInputs */
/** @typedef {{}} Slip_TitleInputs */
/** @typedef {{}} SomeoneInputs */
/** @typedef {{}} Start_BreakInputs */
/** @typedef {{}} Stat_ChoresInputs */
/** @typedef {{}} Stat_FreezesInputs */
/** @typedef {{ best: NonNullable<unknown> }} Stat_StreakInputs */
/** @typedef {{}} Step_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Step_DeleteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Step_Done_ByInputs */
/** @typedef {{ n: NonNullable<unknown> }} Step_NInputs */
/** @typedef {{ step: NonNullable<unknown>, total: NonNullable<unknown> }} Step_OfInputs */
/** @typedef {{}} Step_PlaceholderInputs */
/** @typedef {{ n: NonNullable<unknown> }} Step_RemoveInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Step_Up_NextInputs */
/** @typedef {{}} Sticker_BirdInputs */
/** @typedef {{}} Sticker_BucketInputs */
/** @typedef {{}} Sticker_CatInputs */
/** @typedef {{}} Sticker_CrownInputs */
/** @typedef {{}} Sticker_FishInputs */
/** @typedef {{}} Sticker_FlowerInputs */
/** @typedef {{ rarity: NonNullable<unknown> }} Sticker_LabelInputs */
/** @typedef {{}} Sticker_LampInputs */
/** @typedef {{}} Sticker_LemonInputs */
/** @typedef {{}} Sticker_PlantInputs */
/** @typedef {{}} Sticker_RainbowInputs */
/** @typedef {{}} Sticker_RobotInputs */
/** @typedef {{}} Sticker_ShirtInputs */
/** @typedef {{}} Sticker_SoapInputs */
/** @typedef {{}} Sticker_SparklesInputs */
/** @typedef {{}} Sticker_SpongeInputs */
/** @typedef {{}} Sticker_SprayInputs */
/** @typedef {{}} Sticker_TeaInputs */
/** @typedef {{}} Sticker_WandInputs */
/** @typedef {{}} Sticker_WasherInputs */
/** @typedef {{}} StickersInputs */
/** @typedef {{ owned: NonNullable<unknown>, total: NonNullable<unknown> }} Stickers_FoundInputs */
/** @typedef {{}} Stickers_HintInputs */
/** @typedef {{ count: NonNullable<unknown> }} Streak_DaysInputs */
/** @typedef {{}} SuppliesInputs */
/** @typedef {{}} Supplies_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Supplies_Added_ByInputs */
/** @typedef {{}} Supplies_BoughtInputs */
/** @typedef {{}} Supplies_ClearInputs */
/** @typedef {{}} Supplies_EmptyInputs */
/** @typedef {{}} Supplies_PlaceholderInputs */
/** @typedef {{ count: NonNullable<unknown> }} Supplies_SubInputs */
/** @typedef {{}} Supplies_Sub_EmptyInputs */
/** @typedef {{}} SwapInputs */
/** @typedef {{}} SwappedInputs */
/** @typedef {{}} Switched_Off_BodyInputs */
/** @typedef {{}} Switched_Off_EmptyInputs */
/** @typedef {{}} Switched_Off_TitleInputs */
/** @typedef {{}} Tab_ChoresInputs */
/** @typedef {{}} Tab_HouseInputs */
/** @typedef {{}} Tab_ProfileInputs */
/** @typedef {{}} Tab_TodayInputs */
/** @typedef {{}} Take_BonusInputs */
/** @typedef {{}} Take_BreakInputs */
/** @typedef {{}} Take_Break_SubInputs */
/** @typedef {{}} Takes_AboutInputs */
/** @typedef {{}} Tap_To_ContinueInputs */
/** @typedef {{}} TestInputs */
/** @typedef {{}} Test_NoneInputs */
/** @typedef {{}} Test_SentInputs */
/** @typedef {{}} This_DeviceInputs */
/** @typedef {{}} TimerInputs */
/** @typedef {{}} Timer_ClearInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timer_Done_AtInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timer_Finished_AtInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Timer_GoInputs */
/** @typedef {{}} Timer_How_LongInputs */
/** @typedef {{}} Timer_IntroInputs */
/** @typedef {{}} Timer_Intro_No_PushInputs */
/** @typedef {{}} Timer_Kind_DishwasherInputs */
/** @typedef {{}} Timer_Kind_DryerInputs */
/** @typedef {{}} Timer_Kind_OtherInputs */
/** @typedef {{}} Timer_Kind_OvenInputs */
/** @typedef {{}} Timer_Kind_WasherInputs */
/** @typedef {{}} Timer_MachineInputs */
/** @typedef {{}} Timer_MinutesInputs */
/** @typedef {{}} Timer_NewInputs */
/** @typedef {{}} Timer_New_SubInputs */
/** @typedef {{}} Timer_PauseInputs */
/** @typedef {{}} Timer_RestartInputs */
/** @typedef {{}} Timer_ResumeInputs */
/** @typedef {{}} Timer_StartInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timer_Start_AtInputs */
/** @typedef {{}} Timer_StopInputs */
/** @typedef {{}} Timers_TitleInputs */
/** @typedef {{}} Times_UpInputs */
/** @typedef {{}} TodayInputs */
/** @typedef {{}} Toilet_In_BathroomInputs */
/** @typedef {{}} Toilet_SeparateInputs */
/** @typedef {{}} TradeInputs */
/** @typedef {{}} Trade_AcceptInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_AskInputs */
/** @typedef {{}} Trade_DeclineInputs */
/** @typedef {{}} Trade_DoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_IncomingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_SentInputs */
/** @typedef {{}} Trade_TheirsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Trade_WaitingInputs */
/** @typedef {{}} Trade_You_GetInputs */
/** @typedef {{}} Trade_You_GiveInputs */
/** @typedef {{}} Trade_YoursInputs */
/** @typedef {{}} Treat_AddInputs */
/** @typedef {{}} Treat_Name_LabelInputs */
/** @typedef {{}} Treat_Name_PlaceholderInputs */
/** @typedef {{}} Treat_Price_LabelInputs */
/** @typedef {{}} Treat_RedeemInputs */
/** @typedef {{}} Treats_EarnedInputs */
/** @typedef {{}} Treats_EmptyInputs */
/** @typedef {{}} Treats_IntroInputs */
/** @typedef {{}} Treats_Row_SubInputs */
/** @typedef {{}} Treats_TitleInputs */
/** @typedef {{}} Try_AgainInputs */
/** @typedef {{}} Turn_OnInputs */
/** @typedef {{}} Turn_On_RemindersInputs */
/** @typedef {{ tz: NonNullable<unknown> }} Tz_NoteInputs */
/** @typedef {{ tz: NonNullable<unknown> }} Tz_SwitchInputs */
/** @typedef {{}} Verdict_BalancedInputs */
/** @typedef {{}} Verdict_TightInputs */
/** @typedef {{}} Verdict_Too_MuchInputs */
/** @typedef {{}} WeatherInputs */
/** @typedef {{}} Weather_IntroInputs */
/** @typedef {{}} Weather_NoneInputs */
/** @typedef {{}} Weather_RemoveInputs */
/** @typedef {{}} Weather_SearchInputs */
/** @typedef {{}} Weather_Sub_OffInputs */
/** @typedef {{ place: NonNullable<unknown> }} Weather_Sub_OnInputs */
/** @typedef {{}} Weather_TitleInputs */
/** @typedef {{}} Welcome_CreateInputs */
/** @typedef {{}} Welcome_JoinInputs */
/** @typedef {{}} Welcome_LinkInputs */
/** @typedef {{}} Who_Does_ItInputs */
/** @typedef {{}} Who_Does_It_HintInputs */
/** @typedef {{ xp: NonNullable<unknown>, next: NonNullable<unknown>, name: NonNullable<unknown> }} Xp_Until_GrowsInputs */
/** @typedef {{}} YayInputs */
/** @typedef {{ count: NonNullable<unknown> }} Year_DaysInputs */
/** @typedef {{}} Year_EmptyInputs */
/** @typedef {{}} Year_EndInputs */
/** @typedef {{}} Year_FavInputs */
/** @typedef {{}} Year_High_FivesInputs */
/** @typedef {{ year: NonNullable<unknown> }} Year_IntroInputs */
/** @typedef {{}} Year_Intro_SubInputs */
/** @typedef {{ month: NonNullable<unknown> }} Year_MonthInputs */
/** @typedef {{ pet: NonNullable<unknown>, stage: NonNullable<unknown> }} Year_PetInputs */
/** @typedef {{}} Year_RoomInputs */
/** @typedef {{ year: NonNullable<unknown> }} Year_RowInputs */
/** @typedef {{}} Year_Row_SubInputs */
/** @typedef {{}} Year_RunInputs */
/** @typedef {{}} Year_Run_SubInputs */
/** @typedef {{}} Year_ShareInputs */
/** @typedef {{ count: NonNullable<unknown> }} Year_TimesInputs */
/** @typedef {{}} Year_TotalInputs */
/** @typedef {{}} YesterdayInputs */
/** @typedef {{}} YouInputs */
/** @typedef {{}} You_SuffixInputs */
/** @typedef {{}} Your_ColourInputs */
/** @typedef {{}} Your_CompanionInputs */
/** @typedef {{}} Your_DevicesInputs */
/** @typedef {{}} Your_HomeInputs */
/** @typedef {{}} Your_Home_SubInputs */
/** @typedef {{}} Your_Home_UnsetInputs */
/** @typedef {{}} Your_NameInputs */
/** @typedef {{}} Your_WeekInputs */
import * as registry from "../registry.js"


export const active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

export const active_sub = /** @type {(inputs: Active_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switched-off chores are never picked`)
};

export const activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity`)
};

export const activity_empty = /** @type {(inputs: Activity_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finished chores will show up here.`)
};

export const activity_empty_person = /** @type {(inputs: Activity_Empty_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} hasn't done any chores yet.`)
};

export const add_chore = /** @type {(inputs: Add_ChoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add chore`)
};

export const add_home_first = /** @type {(inputs: Add_Home_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to Home Screen first`)
};

export const ago_days = /** @type {(inputs: Ago_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} day ago`);
	return /** @type {LocalizedString} */ (`${i?.count} days ago`)
	
};

export const ago_hours = /** @type {(inputs: Ago_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} h ago`)
};

export const ago_minutes = /** @type {(inputs: Ago_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min ago`)
};

export const ago_now = /** @type {(inputs: Ago_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`just now`)
};

export const anyone = /** @type {(inputs: AnyoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone`)
};

export const app_tagline = /** @type {(inputs: App_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One small chore a day keeps the whole house in shape.`)
};

export const back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

export const badge_bonus10_desc = /** @type {(inputs: Badge_Bonus10_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish 10 bonus chores`)
};

export const badge_bonus10_name = /** @type {(inputs: Badge_Bonus10_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overachiever`)
};

export const badge_bonus_desc = /** @type {(inputs: Badge_Bonus_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish a bonus chore`)
};

export const badge_bonus_name = /** @type {(inputs: Badge_Bonus_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra Mile`)
};

export const badge_done10_desc = /** @type {(inputs: Badge_Done10_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete 10 chores`)
};

export const badge_done10_name = /** @type {(inputs: Badge_Done10_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting the Hang of It`)
};

export const badge_done250_desc = /** @type {(inputs: Badge_Done250_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete 250 chores`)
};

export const badge_done250_name = /** @type {(inputs: Badge_Done250_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keeper of the Castle`)
};

export const badge_done50_desc = /** @type {(inputs: Badge_Done50_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete 50 chores`)
};

export const badge_done50_name = /** @type {(inputs: Badge_Done50_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habit Formed`)
};

export const badge_early_desc = /** @type {(inputs: Badge_Early_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish a chore before 8am`)
};

export const badge_early_name = /** @type {(inputs: Badge_Early_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Bird`)
};

export const badge_first_desc = /** @type {(inputs: Badge_First_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete your first chore`)
};

export const badge_first_name = /** @type {(inputs: Badge_First_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fresh Start`)
};

export const badge_freeze_desc = /** @type {(inputs: Badge_Freeze_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a streak freeze save your streak`)
};

export const badge_freeze_name = /** @type {(inputs: Badge_Freeze_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved by the Ice`)
};

export const badge_level10_desc = /** @type {(inputs: Badge_Level10_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reach level 10`)
};

export const badge_level10_name = /** @type {(inputs: Badge_Level10_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superstar`)
};

export const badge_level5_desc = /** @type {(inputs: Badge_Level5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reach level 5`)
};

export const badge_level5_name = /** @type {(inputs: Badge_Level5_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rising Star`)
};

export const badge_night_desc = /** @type {(inputs: Badge_Night_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish a chore after 10pm`)
};

export const badge_night_name = /** @type {(inputs: Badge_Night_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Night Owl`)
};

export const badge_rare_desc = /** @type {(inputs: Badge_Rare_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete a chore that comes up twice a year or less`)
};

export const badge_rare_name = /** @type {(inputs: Badge_Rare_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rare Find`)
};

export const badge_rescue_desc = /** @type {(inputs: Badge_Rescue_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do a chore that was a whole period overdue`)
};

export const badge_rescue_name = /** @type {(inputs: Badge_Rescue_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rescue Mission`)
};

export const badge_room_desc = /** @type {(inputs: Badge_Room_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get every chore in a room (3+ chores) up to date`)
};

export const badge_room_name = /** @type {(inputs: Badge_Room_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Room Hero`)
};

export const badge_stickers10_desc = /** @type {(inputs: Badge_Stickers10_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collect 10 different stickers`)
};

export const badge_stickers10_name = /** @type {(inputs: Badge_Stickers10_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collector`)
};

export const badge_streak100_desc = /** @type {(inputs: Badge_Streak100_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reach a 100-day streak`)
};

export const badge_streak100_name = /** @type {(inputs: Badge_Streak100_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centurion`)
};

export const badge_streak30_desc = /** @type {(inputs: Badge_Streak30_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reach a 30-day streak`)
};

export const badge_streak30_name = /** @type {(inputs: Badge_Streak30_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month of Magic`)
};

export const badge_streak3_desc = /** @type {(inputs: Badge_Streak3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reach a 3-day streak`)
};

export const badge_streak3_name = /** @type {(inputs: Badge_Streak3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warming Up`)
};

export const badge_streak7_desc = /** @type {(inputs: Badge_Streak7_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reach a 7-day streak`)
};

export const badge_streak7_name = /** @type {(inputs: Badge_Streak7_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week Warrior`)
};

export const badge_team_desc = /** @type {(inputs: Badge_Team_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone in the household finished their chore on the same day`)
};

export const badge_team_name = /** @type {(inputs: Badge_Team_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dream Team`)
};

export const badges = /** @type {(inputs: BadgesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badges`)
};

export const big_job = /** @type {(inputs: Big_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Big job`)
};

export const big_jobs = /** @type {(inputs: Big_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Big jobs`)
};

export const bonus = /** @type {(inputs: BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus`)
};

export const break_body = /** @type {(inputs: Break_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No chores and no reminders until then. Your streak is paused, not lost.`)
};

export const break_days = /** @type {(inputs: Break_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} day`);
	return /** @type {LocalizedString} */ (`${i?.count} days`)
	
};

export const break_end = /** @type {(inputs: Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End break`)
};

export const break_ends = /** @type {(inputs: Break_EndsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ends on ${i?.date}`)
};

export const break_how_long = /** @type {(inputs: Break_How_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long will you be away?`)
};

export const break_reassure = /** @type {(inputs: Break_ReassureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your streak is paused and kept. No chores or reminders, and your housemates' lists don't change.`)
};

export const break_sick = /** @type {(inputs: Break_SickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sick`)
};

export const break_sick_title = /** @type {(inputs: Break_Sick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get well soon`)
};

export const break_title = /** @type {(inputs: Break_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy your break`)
};

export const break_today = /** @type {(inputs: Break_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just today`)
};

export const break_two_weeks = /** @type {(inputs: Break_Two_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 weeks`)
};

export const break_until = /** @type {(inputs: Break_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Until ${i?.date}`)
};

export const break_vacation = /** @type {(inputs: Break_VacationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacation`)
};

export const break_week = /** @type {(inputs: Break_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 week`)
};

export const break_weekend = /** @type {(inputs: Break_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Until Sunday`)
};

export const buy = /** @type {(inputs: BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy`)
};

export const buy_confirm_body = /** @type {(inputs: Buy_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} coins. ${i?.pet} puts it on straight away.`)
};

export const buy_confirm_title = /** @type {(inputs: Buy_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buy the ${i?.item}?`)
};

export const calendar_break = /** @type {(inputs: Calendar_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Break from chores`)
};

export const calendar_copied = /** @type {(inputs: Calendar_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied`)
};

export const calendar_copy = /** @type {(inputs: Calendar_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

export const calendar_create = /** @type {(inputs: Calendar_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create my calendar link`)
};

export const calendar_done = /** @type {(inputs: Calendar_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Done: ${i?.chore}`)
};

export const calendar_google = /** @type {(inputs: Calendar_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Calendar: Other calendars, From URL, then paste the link.`)
};

export const calendar_guests = /** @type {(inputs: Calendar_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests coming`)
};

export const calendar_intro = /** @type {(inputs: Calendar_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe once and your calendar shows today's chore, the chores that are yours, breaks and guests. It updates by itself every few hours.`)
};

export const calendar_linked = /** @type {(inputs: Calendar_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your calendar link is active. For safety it's only shown once: get a new one if you need it again.`)
};

export const calendar_minutes = /** @type {(inputs: Calendar_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About ${i?.minutes} minutes`)
};

export const calendar_name = /** @type {(inputs: Calendar_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.household} chores`)
};

export const calendar_open = /** @type {(inputs: Calendar_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in Calendar`)
};

export const calendar_private = /** @type {(inputs: Calendar_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone with this link can see your chores, so keep it to yourself.`)
};

export const calendar_reset = /** @type {(inputs: Calendar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a new link`)
};

export const calendar_row_on = /** @type {(inputs: Calendar_Row_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your calendar is linked`)
};

export const calendar_row_sub = /** @type {(inputs: Calendar_Row_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See today's chore next to your plans`)
};

export const calendar_stop = /** @type {(inputs: Calendar_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop the calendar`)
};

export const calendar_title = /** @type {(inputs: Calendar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chores in your calendar`)
};

export const calendar_yours = /** @type {(inputs: Calendar_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your chore`)
};

export const cancel = /** @type {(inputs: CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const chore_added = /** @type {(inputs: Chore_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chore added`)
};

export const chore_aquarium = /** @type {(inputs: Chore_AquariumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change some aquarium water and wipe the glass`)
};

export const chore_balcony = /** @type {(inputs: Chore_BalconyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sweep the balcony / patio`)
};

export const chore_bath_mats = /** @type {(inputs: Chore_Bath_MatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wash bath mats and swap towels`)
};

export const chore_bathroom_floor = /** @type {(inputs: Chore_Bathroom_FloorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mop the bathroom floor`)
};

export const chore_bathroom_sink = /** @type {(inputs: Chore_Bathroom_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean the sink and mirror`)
};

export const chore_bathtub = /** @type {(inputs: Chore_BathtubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrub the bathtub`)
};

export const chore_bin = /** @type {(inputs: Chore_BinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wash out the bin`)
};

export const chore_bird_cage = /** @type {(inputs: Chore_Bird_CageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean the bird cage`)
};

export const chore_cabinets = /** @type {(inputs: Chore_CabinetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wipe cabinet fronts and handles`)
};

export const chore_cage = /** @type {(inputs: Chore_CageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean out the cage`)
};

export const chore_curtains = /** @type {(inputs: Chore_CurtainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wash the curtains`)
};

export const chore_descale_kettle = /** @type {(inputs: Chore_Descale_KettleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descale the kettle / coffee machine`)
};

export const chore_desk = /** @type {(inputs: Chore_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear and wipe the desk`)
};

export const chore_dining_table = /** @type {(inputs: Chore_Dining_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wipe the dining table and chairs`)
};

export const chore_dishwasher_filter = /** @type {(inputs: Chore_Dishwasher_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean the dishwasher filter`)
};

export const chore_doors = /** @type {(inputs: Chore_DoorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wipe down all the doors and frames`)
};

export const chore_drawer = /** @type {(inputs: Chore_DrawerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declutter one drawer`)
};

export const chore_dryer_lint = /** @type {(inputs: Chore_Dryer_LintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean the dryer's lint filter and condenser`)
};

export const chore_dust = /** @type {(inputs: Chore_DustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dust surfaces and shelves`)
};

export const chore_fans = /** @type {(inputs: Chore_FansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dust ceiling fans and light fixtures`)
};

export const chore_freezer = /** @type {(inputs: Chore_FreezerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defrost the freezer`)
};

export const chore_fridge_clearout = /** @type {(inputs: Chore_Fridge_ClearoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear out the fridge (toss old food, wipe spills)`)
};

export const chore_fridge_deep = /** @type {(inputs: Chore_Fridge_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep clean the fridge shelves`)
};

export const chore_garage = /** @type {(inputs: Chore_GarageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sweep and tidy the garage`)
};

export const chore_garden_furniture = /** @type {(inputs: Chore_Garden_FurnitureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean the garden furniture`)
};

export const chore_grout = /** @type {(inputs: Chore_GroutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrub the grout`)
};

export const chore_guest_room = /** @type {(inputs: Chore_Guest_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dust and air the guest room`)
};

export const chore_gutters = /** @type {(inputs: Chore_GuttersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear the gutters`)
};

export const chore_hallway = /** @type {(inputs: Chore_HallwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sweep the hallway and shake out the doormat`)
};

export const chore_hood_filter = /** @type {(inputs: Chore_Hood_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Degrease the extractor hood filter`)
};

export const chore_kitchen_sink = /** @type {(inputs: Chore_Kitchen_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrub the sink and drain`)
};

export const chore_laundry_room = /** @type {(inputs: Chore_Laundry_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidy and wipe the laundry room`)
};

export const chore_litter_box = /** @type {(inputs: Chore_Litter_BoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh the whole litter box`)
};

export const chore_mattress = /** @type {(inputs: Chore_MattressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotate / flip the mattress`)
};

export const chore_microwave = /** @type {(inputs: Chore_MicrowaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean the microwave`)
};

export const chore_mop_kitchen = /** @type {(inputs: Chore_Mop_KitchenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mop the kitchen floor`)
};

export const chore_n_of = /** @type {(inputs: Chore_N_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} of ${i?.total}`)
};

export const chore_name_label = /** @type {(inputs: Chore_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chore name`)
};

export const chore_nightstand = /** @type {(inputs: Chore_NightstandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declutter the nightstand and dresser`)
};

export const chore_oven = /** @type {(inputs: Chore_OvenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean the oven`)
};

export const chore_pantry = /** @type {(inputs: Chore_PantryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declutter the pantry and check expiry dates`)
};

export const chore_pet_bed = /** @type {(inputs: Chore_Pet_BedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wash the pet bed and blankets`)
};

export const chore_pet_bowls = /** @type {(inputs: Chore_Pet_BowlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wash the food and water bowls`)
};

export const chore_pet_hair = /** @type {(inputs: Chore_Pet_HairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacuum pet hair off the sofa`)
};

export const chore_pet_toys = /** @type {(inputs: Chore_Pet_ToysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wash the toys and the lead`)
};

export const chore_pillows = /** @type {(inputs: Chore_PillowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wash pillows and duvet`)
};

export const chore_placeholder = /** @type {(inputs: Chore_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What needs doing?`)
};

export const chore_plant_leaves = /** @type {(inputs: Chore_Plant_LeavesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dust the plant leaves`)
};

export const chore_plants = /** @type {(inputs: Chore_PlantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Water the plants`)
};

export const chore_radiators = /** @type {(inputs: Chore_RadiatorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bleed the radiators`)
};

export const chore_rugs = /** @type {(inputs: Chore_RugsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shake out rugs and doormats`)
};

export const chore_screens = /** @type {(inputs: Chore_ScreensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dust the screens and keyboard`)
};

export const chore_sheets = /** @type {(inputs: Chore_SheetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the bed sheets`)
};

export const chore_shower = /** @type {(inputs: Chore_ShowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrub the shower / bath`)
};

export const chore_shower_curtain = /** @type {(inputs: Chore_Shower_CurtainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wash the shower curtain / clean the screen`)
};

export const chore_showerhead = /** @type {(inputs: Chore_ShowerheadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descale the showerhead and taps`)
};

export const chore_skirting = /** @type {(inputs: Chore_SkirtingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dust the skirting boards`)
};

export const chore_smoke_alarms = /** @type {(inputs: Chore_Smoke_AlarmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test the smoke alarms`)
};

export const chore_sofa = /** @type {(inputs: Chore_SofaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacuum the sofa and fluff the cushions`)
};

export const chore_stairs = /** @type {(inputs: Chore_StairsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacuum the stairs`)
};

export const chore_stovetop = /** @type {(inputs: Chore_StovetopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Degrease the stovetop`)
};

export const chore_switches = /** @type {(inputs: Chore_SwitchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wipe light switches, remotes and door handles`)
};

export const chore_toilet = /** @type {(inputs: Chore_ToiletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean the toilet`)
};

export const chore_toilet_basin = /** @type {(inputs: Chore_Toilet_BasinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wipe the hand basin and toilet floor`)
};

export const chore_under_bed = /** @type {(inputs: Chore_Under_BedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacuum under the bed`)
};

export const chore_vacuum_filter = /** @type {(inputs: Chore_Vacuum_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean the vacuum cleaner filter`)
};

export const chore_vacuum_living = /** @type {(inputs: Chore_Vacuum_LivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacuum the living room`)
};

export const chore_wardrobe = /** @type {(inputs: Chore_WardrobeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort the wardrobe: donate what you don't wear`)
};

export const chore_washing_machine = /** @type {(inputs: Chore_Washing_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run a washing machine cleaning cycle and wipe the seal`)
};

export const chore_weeding = /** @type {(inputs: Chore_WeedingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weed the garden`)
};

export const chore_windows_inside = /** @type {(inputs: Chore_Windows_InsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean the windows (inside)`)
};

export const chore_windows_outside = /** @type {(inputs: Chore_Windows_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean the outside of the windows`)
};

export const chores_count = /** @type {(inputs: Chores_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} chore`);
	return /** @type {LocalizedString} */ (`${i?.count} chores`)
	
};

export const chores_on = /** @type {(inputs: Chores_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} chores switched on`)
};

export const cleanliness = /** @type {(inputs: CleanlinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cleanliness`)
};

export const close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const coins_label = /** @type {(inputs: Coins_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coins`)
};

export const coins_n = /** @type {(inputs: Coins_NInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} coin`);
	return /** @type {LocalizedString} */ (`${i?.count} coins`)
	
};

export const colour = /** @type {(inputs: ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colour`)
};

export const companion = /** @type {(inputs: CompanionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companion`)
};

export const confirm_delete_chore = /** @type {(inputs: Confirm_Delete_ChoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this chore for everyone in the household?`)
};

export const confirm_leave = /** @type {(inputs: Confirm_LeaveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leave “${i?.household}”? Your progress will be deleted. If you're the last member, the household is deleted too.`)
};

export const confirm_sign_out = /** @type {(inputs: Confirm_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll need an invite or device code to sign in again on this device.`)
};

export const _continue = /** @type {(inputs: _ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

export const copy_code = /** @type {(inputs: Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy code`)
};

export const crash_body = /** @type {(inputs: Crash_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry about that. Reloading usually fixes it; your chores are safe.`)
};

export const crash_title = /** @type {(inputs: Crash_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something broke`)
};

export const create_household = /** @type {(inputs: Create_HouseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create household`)
};

export const daily_time = /** @type {(inputs: Daily_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily time`)
};

export const daily_time_sub = /** @type {(inputs: Daily_Time_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longer chores are picked only when nothing else is due`)
};

export const days_overdue = /** @type {(inputs: Days_OverdueInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} day overdue`);
	return /** @type {LocalizedString} */ (`${i?.count} days overdue`)
	
};

export const _delete = /** @type {(inputs: _DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const delete_chore = /** @type {(inputs: Delete_ChoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete chore`)
};

export const device_app = /** @type {(inputs: Device_AppInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.os} · App`)
};

export const device_code = /** @type {(inputs: Device_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Device code`)
};

export const device_generic = /** @type {(inputs: Device_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Device`)
};

export const device_name = /** @type {(inputs: Device_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.browser} on ${i?.os}`)
};

export const done = /** @type {(inputs: DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

export const done_button = /** @type {(inputs: Done_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

export const done_for_today = /** @type {(inputs: Done_For_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done for today`)
};

export const dry_day = /** @type {(inputs: Dry_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dry day: good weather for this`)
};

export const due_in_days = /** @type {(inputs: Due_In_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Due in ${i?.count} days`)
};

export const due_today = /** @type {(inputs: Due_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due today`)
};

export const due_tomorrow = /** @type {(inputs: Due_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due tomorrow`)
};

export const duration_h = /** @type {(inputs: Duration_HInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours} h`)
};

export const duration_h_m = /** @type {(inputs: Duration_H_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hours} h ${i?.minutes} min`)
};

export const easier_one = /** @type {(inputs: Easier_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Easier one`)
};

export const edit_chore = /** @type {(inputs: Edit_ChoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit chore`)
};

export const effort = /** @type {(inputs: EffortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effort`)
};

export const effort_1 = /** @type {(inputs: Effort_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Easy`)
};

export const effort_2 = /** @type {(inputs: Effort_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

export const effort_3 = /** @type {(inputs: Effort_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hard`)
};

export const err_already_done = /** @type {(inputs: Err_Already_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That one is already taken care of.`)
};

export const err_assignment_not_found = /** @type {(inputs: Err_Assignment_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That chore isn't on your list.`)
};

export const err_avatar = /** @type {(inputs: Err_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick one of the avatar colours.`)
};

export const err_bonus_needs_daily = /** @type {(inputs: Err_Bonus_Needs_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish today's chore first, then grab a bonus.`)
};

export const err_bonus_none = /** @type {(inputs: Err_Bonus_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing left to do today. The house is sparkling.`)
};

export const err_bonus_pending = /** @type {(inputs: Err_Bonus_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already have a bonus chore waiting.`)
};

export const err_chore_name = /** @type {(inputs: Err_Chore_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill in the chore name.`)
};

export const err_chore_not_found = /** @type {(inputs: Err_Chore_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chore not found.`)
};

export const err_code = /** @type {(inputs: Err_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill in the code.`)
};

export const err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That request wasn't allowed. Reload the page and try again.`)
};

export const err_freezes_full = /** @type {(inputs: Err_Freezes_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already have as many streak freezes as you can hold.`)
};

export const err_freq = /** @type {(inputs: Err_FreqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose between 1 and 730 days.`)
};

export const err_generic = /** @type {(inputs: Err_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong.`)
};

export const err_guests_date = /** @type {(inputs: Err_Guests_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a day in the next two months.`)
};

export const err_high_five_self = /** @type {(inputs: Err_High_Five_SelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can't high-five yourself. (Nice try.)`)
};

export const err_household_name = /** @type {(inputs: Err_Household_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill in a household name.`)
};

export const err_household_too_small = /** @type {(inputs: Err_Household_Too_SmallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There are already ${i?.count} people in this household.`)
};

export const err_invalid = /** @type {(inputs: Err_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check what you filled in.`)
};

export const err_invite_code = /** @type {(inputs: Err_Invite_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill in the invite code.`)
};

export const err_invite_not_found = /** @type {(inputs: Err_Invite_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That invite code doesn't match any household.`)
};

export const err_item_owned = /** @type {(inputs: Err_Item_OwnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already have that one.`)
};

export const err_link_invalid = /** @type {(inputs: Err_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code is invalid or has expired.`)
};

export const err_member_not_found = /** @type {(inputs: Err_Member_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member not found.`)
};

export const err_no_connection = /** @type {(inputs: Err_No_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're offline. Check your connection and try again.`)
};

export const err_no_swap_option = /** @type {(inputs: Err_No_Swap_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No other chore available to swap to.`)
};

export const err_not_enough_coins = /** @type {(inputs: Err_Not_Enough_CoinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough coins yet.`)
};

export const err_not_found = /** @type {(inputs: Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not found.`)
};

export const err_nothing_to_swap = /** @type {(inputs: Err_Nothing_To_SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing to swap right now.`)
};

export const err_offline = /** @type {(inputs: Err_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't reach the server. Are you offline?`)
};

export const err_owner = /** @type {(inputs: Err_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That person isn't in this household.`)
};

export const err_pause_past = /** @type {(inputs: Err_Pause_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A break can't end in the past.`)
};

export const err_pause_too_long = /** @type {(inputs: Err_Pause_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A break can last at most a year.`)
};

export const err_people_max = /** @type {(inputs: Err_People_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to 8 people are supported.`)
};

export const err_people_min = /** @type {(inputs: Err_People_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At least one person lives here.`)
};

export const err_pet_name = /** @type {(inputs: Err_Pet_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill in a pet name.`)
};

export const err_photo_invalid = /** @type {(inputs: Err_Photo_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That doesn't look like a photo. Try a JPEG or PNG.`)
};

export const err_photo_too_big = /** @type {(inputs: Err_Photo_Too_BigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That photo is too big.`)
};

export const err_places_unavailable = /** @type {(inputs: Err_Places_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The weather service isn't answering. Try again later.`)
};

export const err_project_last_step = /** @type {(inputs: Err_Project_Last_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A big job needs at least one step. Delete the job instead.`)
};

export const err_project_name = /** @type {(inputs: Err_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give the job a name.`)
};

export const err_project_steps = /** @type {(inputs: Err_Project_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add at least one step (20 at most).`)
};

export const err_push_subscription = /** @type {(inputs: Err_Push_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid push subscription.`)
};

export const err_rate_limited = /** @type {(inputs: Err_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many tries. Wait a minute and try again.`)
};

export const err_room = /** @type {(inputs: Err_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill in the room.`)
};

export const err_schedule_empty = /** @type {(inputs: Err_Schedule_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick at least one day with a chore.`)
};

export const err_server = /** @type {(inputs: Err_ServerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong on our side.`)
};

export const err_sign_in = /** @type {(inputs: Err_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please sign in.`)
};

export const err_sign_in_again = /** @type {(inputs: Err_Sign_In_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please sign in again.`)
};

export const err_step_name = /** @type {(inputs: Err_Step_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the step?`)
};

export const err_supplies_full = /** @type {(inputs: Err_Supplies_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The list is full. Tick some things off first.`)
};

export const err_supply_name = /** @type {(inputs: Err_Supply_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do you need?`)
};

export const err_swap_used = /** @type {(inputs: Err_Swap_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already used your swap today.`)
};

export const err_time_format = /** @type {(inputs: Err_Time_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reminder time must look like 18:30.`)
};

export const err_timeout = /** @type {(inputs: Err_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The server took too long to answer. Try again.`)
};

export const err_timer_minutes = /** @type {(inputs: Err_Timer_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick between 1 and 360 minutes.`)
};

export const err_timers_full = /** @type {(inputs: Err_Timers_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That's a lot of machines at once. Clear a finished one first.`)
};

export const err_too_large = /** @type {(inputs: Err_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request too large.`)
};

export const err_too_long = /** @type {(inputs: Err_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That's too long.`)
};

export const err_trade_gone = /** @type {(inputs: Err_Trade_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That trade isn't open any more.`)
};

export const err_trade_nothing = /** @type {(inputs: Err_Trade_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You both need a chore waiting today to trade.`)
};

export const err_trade_owned = /** @type {(inputs: Err_Trade_OwnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of these chores belongs to someone, so it can't be traded.`)
};

export const err_treat_name = /** @type {(inputs: Err_Treat_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the treat?`)
};

export const err_treat_price = /** @type {(inputs: Err_Treat_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a price between 10 and 100,000 coins.`)
};

export const err_treats_full = /** @type {(inputs: Err_Treats_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That's a lot of treats! Remove one first.`)
};

export const err_tz = /** @type {(inputs: Err_TzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown time zone.`)
};

export const err_your_name = /** @type {(inputs: Err_Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please fill in your name.`)
};

export const every_how_many_days = /** @type {(inputs: Every_How_Many_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every how many days`)
};

export const everyone = /** @type {(inputs: EveryoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone`)
};

export const expired = /** @type {(inputs: ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expired. Close this and make a new code.`)
};

export const expires_in = /** @type {(inputs: Expires_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires in ${i?.time}`)
};

export const fair_share = /** @type {(inputs: Fair_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair share`)
};

export const fair_share_empty = /** @type {(inputs: Fair_Share_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough done yet to compare.`)
};

export const fair_share_hint = /** @type {(inputs: Fair_Share_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Effort over the last ${i?.days} days (minutes times how hard). Whoever's doing more gets lighter chores for a while.`)
};

export const first_badge_hint = /** @type {(inputs: First_Badge_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your first chore earns your first badge.`)
};

export const found_sticker = /** @type {(inputs: Found_StickerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`found ${i?.sticker}`)
};

export const freeze_bought = /** @type {(inputs: Freeze_BoughtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streak freeze ready`)
};

export const freeze_confirm_body = /** @type {(inputs: Freeze_Confirm_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} coins. If you miss a chore day, it keeps your streak going.`)
};

export const freeze_confirm_title = /** @type {(inputs: Freeze_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy a streak freeze?`)
};

export const freeze_covered = /** @type {(inputs: Freeze_CoveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A streak freeze covered the missed day`)
};

export const freeze_earned = /** @type {(inputs: Freeze_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streak freeze earned`)
};

export const freeze_earned_sub = /** @type {(inputs: Freeze_Earned_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Covers one missed day automatically`)
};

export const freeze_full = /** @type {(inputs: Freeze_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full`)
};

export const freeze_item = /** @type {(inputs: Freeze_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streak freeze`)
};

export const freeze_item_sub = /** @type {(inputs: Freeze_Item_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Covers a missed chore day · you have ${i?.count} of ${i?.max}`)
};

export const freezes_count = /** @type {(inputs: Freezes_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} freeze`);
	return /** @type {LocalizedString} */ (`${i?.count} freezes`)
	
};

export const freq_2months = /** @type {(inputs: Freq_2monthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every 2 months`)
};

export const freq_2weeks = /** @type {(inputs: Freq_2weeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every 2 weeks`)
};

export const freq_3months = /** @type {(inputs: Freq_3monthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every 3 months`)
};

export const freq_custom = /** @type {(inputs: Freq_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom…`)
};

export const freq_daily = /** @type {(inputs: Freq_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily`)
};

export const freq_every_days = /** @type {(inputs: Freq_Every_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every ${i?.count} days`)
};

export const freq_every_weeks = /** @type {(inputs: Freq_Every_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every ${i?.count} weeks`)
};

export const freq_monthly = /** @type {(inputs: Freq_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

export const freq_twice_year = /** @type {(inputs: Freq_Twice_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twice a year`)
};

export const freq_weekly = /** @type {(inputs: Freq_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly`)
};

export const freq_yearly = /** @type {(inputs: Freq_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly`)
};

export const fully_grown = /** @type {(inputs: Fully_GrownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fully grown`)
};

export const furniture_aquarium = /** @type {(inputs: Furniture_AquariumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aquarium`)
};

export const furniture_bookcase = /** @type {(inputs: Furniture_BookcaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookcase`)
};

export const furniture_clock = /** @type {(inputs: Furniture_ClockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clock`)
};

export const furniture_cushion = /** @type {(inputs: Furniture_CushionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cushion`)
};

export const furniture_disco_ball = /** @type {(inputs: Furniture_Disco_BallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disco ball`)
};

export const furniture_dots = /** @type {(inputs: Furniture_DotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dotty wallpaper`)
};

export const furniture_fairy_lights = /** @type {(inputs: Furniture_Fairy_LightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fairy lights`)
};

export const furniture_floor_lamp = /** @type {(inputs: Furniture_Floor_LampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Floor lamp`)
};

export const furniture_painting = /** @type {(inputs: Furniture_PaintingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painting`)
};

export const furniture_permission = /** @type {(inputs: Furniture_PermissionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pet} got a ${i?.item}! Consider this your permission to treat your own room too.`)
};

export const furniture_plant = /** @type {(inputs: Furniture_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plant`)
};

export const furniture_rug = /** @type {(inputs: Furniture_RugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rug`)
};

export const furniture_shelf = /** @type {(inputs: Furniture_ShelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shelf`)
};

export const furniture_stripes = /** @type {(inputs: Furniture_StripesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Striped wallpaper`)
};

export const furniture_window = /** @type {(inputs: Furniture_WindowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Window`)
};

export const guests_banner = /** @type {(inputs: Guests_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guests ${i?.date}: the rooms they'll see come first.`)
};

export const guests_clear = /** @type {(inputs: Guests_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No guests after all`)
};

export const guests_intro = /** @type {(inputs: Guests_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the days before, the chores visitors notice come first: toilet, living room, hallway, kitchen.`)
};

export const guests_on = /** @type {(inputs: Guests_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guests ${i?.date}`)
};

export const guests_pick = /** @type {(inputs: Guests_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or pick a date`)
};

export const guests_row = /** @type {(inputs: Guests_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests coming?`)
};

export const guests_row_sub = /** @type {(inputs: Guests_Row_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The rooms people see get done first`)
};

export const guests_title = /** @type {(inputs: Guests_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When are guests coming?`)
};

export const guests_tomorrow = /** @type {(inputs: Guests_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow`)
};

export const hide_inactive = /** @type {(inputs: Hide_InactiveInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Hide ${i?.count} switched-off chore`);
	return /** @type {LocalizedString} */ (`Hide ${i?.count} switched-off chores`)
	
};

export const high_five = /** @type {(inputs: High_FiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-five`)
};

export const high_fived = /** @type {(inputs: High_FivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-fived`)
};

export const history = /** @type {(inputs: HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

export const history_empty = /** @type {(inputs: History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not done yet in the app.`)
};

export const home_intro = /** @type {(inputs: Home_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So you only get chores that make sense. You can change this later.`)
};

export const home_pet_bird = /** @type {(inputs: Home_Pet_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bird`)
};

export const home_pet_cat = /** @type {(inputs: Home_Pet_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cat`)
};

export const home_pet_dog = /** @type {(inputs: Home_Pet_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dog`)
};

export const home_pet_fish = /** @type {(inputs: Home_Pet_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fish`)
};

export const home_pet_small_pet = /** @type {(inputs: Home_Pet_Small_PetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabbit or rodent`)
};

export const home_saved = /** @type {(inputs: Home_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chore list updated for your home`)
};

export const home_space_balcony = /** @type {(inputs: Home_Space_BalconyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balcony`)
};

export const home_space_dining = /** @type {(inputs: Home_Space_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dining area`)
};

export const home_space_garage = /** @type {(inputs: Home_Space_GarageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garage`)
};

export const home_space_garden = /** @type {(inputs: Home_Space_GardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garden`)
};

export const home_space_guest_room = /** @type {(inputs: Home_Space_Guest_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest room`)
};

export const home_space_laundry = /** @type {(inputs: Home_Space_LaundryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laundry room`)
};

export const home_space_office = /** @type {(inputs: Home_Space_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home office`)
};

export const home_space_stairs = /** @type {(inputs: Home_Space_StairsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stairs`)
};

export const home_thing_bathtub = /** @type {(inputs: Home_Thing_BathtubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bathtub`)
};

export const home_thing_dishwasher = /** @type {(inputs: Home_Thing_DishwasherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dishwasher`)
};

export const home_thing_dryer = /** @type {(inputs: Home_Thing_DryerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tumble dryer`)
};

export const home_thing_plants = /** @type {(inputs: Home_Thing_PlantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Houseplants`)
};

export const home_title = /** @type {(inputs: Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us about your home`)
};

export const home_type_apartment = /** @type {(inputs: Home_Type_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartment`)
};

export const home_type_house = /** @type {(inputs: Home_Type_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House`)
};

export const household = /** @type {(inputs: HouseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Household`)
};

export const household_name = /** @type {(inputs: Household_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Household name`)
};

export const household_name_placeholder = /** @type {(inputs: Household_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our place`)
};

export const in_season = /** @type {(inputs: In_SeasonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In season: ${i?.months}`)
};

export const install_body = /** @type {(inputs: Install_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It works best as an app: daily reminders, full screen, one tap away on your home screen.`)
};

export const install_button = /** @type {(inputs: Install_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install app`)
};

export const install_done_body = /** @type {(inputs: Install_Done_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open CleanReminder from your home screen or app list to get started.`)
};

export const install_done_title = /** @type {(inputs: Install_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installed`)
};

export const install_invite_note = /** @type {(inputs: Install_Invite_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your invite code. You'll need it in the app:`)
};

export const install_ios_1 = /** @type {(inputs: Install_Ios_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap Share in Safari's toolbar`)
};

export const install_ios_2 = /** @type {(inputs: Install_Ios_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose “Add to Home Screen”`)
};

export const install_open = /** @type {(inputs: Install_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open CleanReminder from your home screen`)
};

export const install_other_1 = /** @type {(inputs: Install_Other_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open your browser's menu`)
};

export const install_other_2 = /** @type {(inputs: Install_Other_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose “Install app” or “Add to Home screen”`)
};

export const install_skip = /** @type {(inputs: Install_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use in the browser instead`)
};

export const install_title = /** @type {(inputs: Install_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install CleanReminder`)
};

export const invite_code = /** @type {(inputs: Invite_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code`)
};

export const invite_code_toast = /** @type {(inputs: Invite_Code_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invite code: ${i?.code}`)
};

export const invite_copied = /** @type {(inputs: Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite link copied`)
};

export const invite_text = /** @type {(inputs: Invite_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Join “${i?.household}” on CleanReminder. Invite code: ${i?.code}`)
};

export const invite_warning = /** @type {(inputs: Invite_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone with the invite code can join, so only share it with people you live with.`)
};

export const ios_home_screen = /** @type {(inputs: Ios_Home_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On iPhone, add the app to your Home Screen first (Share, then Add to Home Screen) and open it from there.`)
};

export const item_beanie = /** @type {(inputs: Item_BeanieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beanie`)
};

export const item_bikini = /** @type {(inputs: Item_BikiniInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bikini`)
};

export const item_bow = /** @type {(inputs: Item_BowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bow`)
};

export const item_broom = /** @type {(inputs: Item_BroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiny broom`)
};

export const item_flower = /** @type {(inputs: Item_FlowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flower`)
};

export const item_glasses = /** @type {(inputs: Item_GlassesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glasses`)
};

export const item_party_hat = /** @type {(inputs: Item_Party_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Party hat`)
};

export const item_permission = /** @type {(inputs: Item_PermissionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pet} got the ${i?.item}! Consider this your permission to buy a real one too.`)
};

export const item_scarf = /** @type {(inputs: Item_ScarfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarf`)
};

export const item_sunglasses = /** @type {(inputs: Item_SunglassesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunglasses`)
};

export const item_sunhat = /** @type {(inputs: Item_SunhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sun hat`)
};

export const join = /** @type {(inputs: JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join`)
};

export const join_household = /** @type {(inputs: Join_HouseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join a household`)
};

export const keep_list = /** @type {(inputs: Keep_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep the list as it is`)
};

export const language = /** @type {(inputs: LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

export const language_auto = /** @type {(inputs: Language_AutoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Same as device (${i?.language})`)
};

export const last_7_days = /** @type {(inputs: Last_7_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 7 days`)
};

export const last_active = /** @type {(inputs: Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last active ${i?.when}`)
};

export const last_done = /** @type {(inputs: Last_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last done`)
};

export const last_done_by = /** @type {(inputs: Last_Done_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} by ${i?.name}`)
};

export const last_done_days = /** @type {(inputs: Last_Done_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Done ${i?.count} days ago`)
};

export const last_done_today = /** @type {(inputs: Last_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done today`)
};

export const last_done_yesterday = /** @type {(inputs: Last_Done_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done yesterday`)
};

export const ld_few_days = /** @type {(inputs: Ld_Few_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A few days ago`)
};

export const ld_few_months = /** @type {(inputs: Ld_Few_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A few months ago`)
};

export const ld_month = /** @type {(inputs: Ld_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A month ago`)
};

export const ld_today = /** @type {(inputs: Ld_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

export const ld_two_weeks = /** @type {(inputs: Ld_Two_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two weeks ago`)
};

export const ld_week = /** @type {(inputs: Ld_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About a week ago`)
};

export const ld_year = /** @type {(inputs: Ld_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over a year ago`)
};

export const ld_yesterday = /** @type {(inputs: Ld_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yesterday`)
};

export const leave_household = /** @type {(inputs: Leave_HouseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave household`)
};

export const level_n = /** @type {(inputs: Level_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Level ${i?.level}`)
};

export const level_title_0 = /** @type {(inputs: Level_Title_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dust Novice`)
};

export const level_title_1 = /** @type {(inputs: Level_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponge Squire`)
};

export const level_title_10 = /** @type {(inputs: Level_Title_10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legend of the Lint Trap`)
};

export const level_title_2 = /** @type {(inputs: Level_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crumb Chaser`)
};

export const level_title_3 = /** @type {(inputs: Level_Title_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mop Knight`)
};

export const level_title_4 = /** @type {(inputs: Level_Title_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broom Baron`)
};

export const level_title_5 = /** @type {(inputs: Level_Title_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrub Sorcerer`)
};

export const level_title_6 = /** @type {(inputs: Level_Title_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duchess of Dusting`)
};

export const level_title_7 = /** @type {(inputs: Level_Title_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidy Titan`)
};

export const level_title_8 = /** @type {(inputs: Level_Title_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grime Slayer`)
};

export const level_title_9 = /** @type {(inputs: Level_Title_9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparkle Sage`)
};

export const level_up_sub = /** @type {(inputs: Level_Up_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You're now a ${i?.title}`)
};

export const link_device = /** @type {(inputs: Link_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link a device`)
};

export const link_device_sub = /** @type {(inputs: Link_Device_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use your account on another phone or computer`)
};

export const link_intro = /** @type {(inputs: Link_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On a device where you're already signed in, open Settings and tap “Link a device”. Enter the code it shows.`)
};

export const link_sheet_body = /** @type {(inputs: Link_Sheet_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the other device, open CleanReminder and choose “Sign in with a device code”.`)
};

export const link_title = /** @type {(inputs: Link_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

export const load_error_title = /** @type {(inputs: Load_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load your house`)
};

export const loading = /** @type {(inputs: LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

export const mark_done = /** @type {(inputs: Mark_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as done`)
};

export const mark_x_done = /** @type {(inputs: Mark_X_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mark ${i?.name} as done`)
};

export const minutes_short = /** @type {(inputs: Minutes_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

export const mood_grumpy = /** @type {(inputs: Mood_GrumpyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grumpy`)
};

export const mood_happy = /** @type {(inputs: Mood_HappyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Happy`)
};

export const mood_meh = /** @type {(inputs: Mood_MehInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meh`)
};

export const mood_sad = /** @type {(inputs: Mood_SadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiding`)
};

export const mood_thriving = /** @type {(inputs: Mood_ThrivingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thriving`)
};

export const name = /** @type {(inputs: NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const never_mind = /** @type {(inputs: Never_MindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never mind`)
};

export const new_chore = /** @type {(inputs: New_ChoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New chore`)
};

export const new_code = /** @type {(inputs: New_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New code`)
};

export const new_household = /** @type {(inputs: New_HouseholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New household`)
};

export const new_room = /** @type {(inputs: New_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New room…`)
};

export const next_badges = /** @type {(inputs: Next_BadgesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next badges`)
};

export const no_chores_available = /** @type {(inputs: No_Chores_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No chores to pick from. Switch some on in Chores.`)
};

export const no_streak = /** @type {(inputs: No_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No streak yet`)
};

export const not_done_yet = /** @type {(inputs: Not_Done_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not done yet`)
};

export const not_now = /** @type {(inputs: Not_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not now`)
};

export const not_sure = /** @type {(inputs: Not_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sure`)
};

export const notes = /** @type {(inputs: NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

export const notes_hint = /** @type {(inputs: Notes_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shown on the chore card, e.g. which cleaner to use.`)
};

export const notes_placeholder = /** @type {(inputs: Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the blue spray, not bleach`)
};

export const nothing_picked = /** @type {(inputs: Nothing_PickedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing picked yet`)
};

export const notif_daily = /** @type {(inputs: Notif_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily chore`)
};

export const notif_daily_sub = /** @type {(inputs: Notif_Daily_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At your reminder time`)
};

export const notif_recap = /** @type {(inputs: Notif_RecapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly recap`)
};

export const notif_recap_sub = /** @type {(inputs: Notif_Recap_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunday at 19:00: how the week went`)
};

export const notif_streak = /** @type {(inputs: Notif_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streak reminder`)
};

export const notif_streak_sub = /** @type {(inputs: Notif_Streak_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At 20:30 if today's chore isn't done`)
};

export const notif_team = /** @type {(inputs: Notif_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Household activity`)
};

export const notif_team_sub = /** @type {(inputs: Notif_Team_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When someone finishes a chore`)
};

export const notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

export const off = /** @type {(inputs: OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off`)
};

export const off_this_device = /** @type {(inputs: Off_This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off on this device`)
};

export const offline_banner = /** @type {(inputs: Offline_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're offline`)
};

export const on_a_break = /** @type {(inputs: On_A_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On a break`)
};

export const overdue_count = /** @type {(inputs: Overdue_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} overdue`)
};

export const people = /** @type {(inputs: PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

export const people_count = /** @type {(inputs: People_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} person`);
	return /** @type {LocalizedString} */ (`${i?.count} people`)
	
};

export const people_hint = /** @type {(inputs: People_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone does one chore a day, so this decides how big your chore list starts. You can change it later.`)
};

export const people_question = /** @type {(inputs: People_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many people live here?`)
};

export const people_sub = /** @type {(inputs: People_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets how many chores are switched on`)
};

export const per_day_needed = /** @type {(inputs: Per_Day_NeededInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.perDay} a day needed`)
};

export const pet_bunny_stage_0 = /** @type {(inputs: Pet_Bunny_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dust Speck`)
};

export const pet_bunny_stage_1 = /** @type {(inputs: Pet_Bunny_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baby Bunny`)
};

export const pet_bunny_stage_2 = /** @type {(inputs: Pet_Bunny_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluffball`)
};

export const pet_bunny_stage_3 = /** @type {(inputs: Pet_Bunny_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grown-up Bunny`)
};

export const pet_bunny_stage_4 = /** @type {(inputs: Pet_Bunny_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majestic Floof`)
};

export const pet_bunny_stage_5 = /** @type {(inputs: Pet_Bunny_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendary Floof`)
};

export const pet_cat_stage_0 = /** @type {(inputs: Pet_Cat_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitten`)
};

export const pet_cat_stage_1 = /** @type {(inputs: Pet_Cat_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiny Tabby`)
};

export const pet_cat_stage_2 = /** @type {(inputs: Pet_Cat_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curious Cat`)
};

export const pet_cat_stage_3 = /** @type {(inputs: Pet_Cat_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House Cat`)
};

export const pet_cat_stage_4 = /** @type {(inputs: Pet_Cat_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majestic Mouser`)
};

export const pet_cat_stage_5 = /** @type {(inputs: Pet_Cat_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendary Lion`)
};

export const pet_chick_stage_0 = /** @type {(inputs: Pet_Chick_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egg`)
};

export const pet_chick_stage_1 = /** @type {(inputs: Pet_Chick_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hatchling`)
};

export const pet_chick_stage_2 = /** @type {(inputs: Pet_Chick_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluffy Chick`)
};

export const pet_chick_stage_3 = /** @type {(inputs: Pet_Chick_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Young Bird`)
};

export const pet_chick_stage_4 = /** @type {(inputs: Pet_Chick_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proud Bird`)
};

export const pet_chick_stage_5 = /** @type {(inputs: Pet_Chick_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendary Phoenix`)
};

export const pet_fox_stage_0 = /** @type {(inputs: Pet_Fox_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiny Kit`)
};

export const pet_fox_stage_1 = /** @type {(inputs: Pet_Fox_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fox Kit`)
};

export const pet_fox_stage_2 = /** @type {(inputs: Pet_Fox_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curious Fox`)
};

export const pet_fox_stage_3 = /** @type {(inputs: Pet_Fox_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clever Fox`)
};

export const pet_fox_stage_4 = /** @type {(inputs: Pet_Fox_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majestic Fox`)
};

export const pet_fox_stage_5 = /** @type {(inputs: Pet_Fox_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendary Nine-Tails`)
};

export const pet_grew_body = /** @type {(inputs: Pet_Grew_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is now a ${i?.stage}. All thanks to your chores.`)
};

export const pet_grew_title = /** @type {(inputs: Pet_Grew_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} grew!`)
};

export const pet_intro = /** @type {(inputs: Pet_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It grows with every chore you do, and its mood shows how the house is doing.`)
};

export const pet_kind_bunny = /** @type {(inputs: Pet_Kind_BunnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dust bunny`)
};

export const pet_kind_cat = /** @type {(inputs: Pet_Kind_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cat`)
};

export const pet_kind_chick = /** @type {(inputs: Pet_Kind_ChickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chick`)
};

export const pet_kind_fox = /** @type {(inputs: Pet_Kind_FoxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fox`)
};

export const pet_kind_pup = /** @type {(inputs: Pet_Kind_PupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pup`)
};

export const pet_kind_sprout = /** @type {(inputs: Pet_Kind_SproutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprout`)
};

export const pet_name_ideas = /** @type {(inputs: Pet_Name_IdeasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluffle,Biscuit,Pip,Mochi,Noodle,Pebble,Waffles,Bean,Sprinkle,Nugget,Maple,Dumpling,Toast,Clover`)
};

export const pet_name_label = /** @type {(inputs: Pet_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pet's name`)
};

export const pet_owner = /** @type {(inputs: Pet_OwnerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}'s`)
};

export const pet_pup_stage_0 = /** @type {(inputs: Pet_Pup_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newborn Pup`)
};

export const pet_pup_stage_1 = /** @type {(inputs: Pet_Pup_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puppy`)
};

export const pet_pup_stage_2 = /** @type {(inputs: Pet_Pup_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good Pup`)
};

export const pet_pup_stage_3 = /** @type {(inputs: Pet_Pup_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best Friend`)
};

export const pet_pup_stage_4 = /** @type {(inputs: Pet_Pup_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Dog`)
};

export const pet_pup_stage_5 = /** @type {(inputs: Pet_Pup_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendary Hound`)
};

export const pet_saved = /** @type {(inputs: Pet_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Say hi to ${i?.name}`)
};

export const pet_shuffle = /** @type {(inputs: Pet_ShuffleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggest a name`)
};

export const pet_sprout_stage_0 = /** @type {(inputs: Pet_Sprout_Stage_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seed`)
};

export const pet_sprout_stage_1 = /** @type {(inputs: Pet_Sprout_Stage_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprout`)
};

export const pet_sprout_stage_2 = /** @type {(inputs: Pet_Sprout_Stage_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seedling`)
};

export const pet_sprout_stage_3 = /** @type {(inputs: Pet_Sprout_Stage_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leafy Friend`)
};

export const pet_sprout_stage_4 = /** @type {(inputs: Pet_Sprout_Stage_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blooming Beauty`)
};

export const pet_sprout_stage_5 = /** @type {(inputs: Pet_Sprout_Stage_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendary Tree`)
};

export const pet_title = /** @type {(inputs: Pet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a companion`)
};

export const pets_title = /** @type {(inputs: Pets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companions`)
};

export const photo_add = /** @type {(inputs: Photo_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add photo`)
};

export const photo_label = /** @type {(inputs: Photo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile photo`)
};

export const photo_read_error = /** @type {(inputs: Photo_Read_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't read that image. Try another photo.`)
};

export const photo_remove = /** @type {(inputs: Photo_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const photo_replace = /** @type {(inputs: Photo_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace`)
};

export const plus_bonus = /** @type {(inputs: Plus_BonusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+ ${i?.count} bonus`)
};

export const project_bonus = /** @type {(inputs: Project_BonusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.coins} bonus coins for finishing a big job`)
};

export const project_create = /** @type {(inputs: Project_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start this job`)
};

export const project_delete = /** @type {(inputs: Project_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete big job`)
};

export const project_delete_body = /** @type {(inputs: Project_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its steps go too. What's already been done stays in the history.`)
};

export const project_delete_title = /** @type {(inputs: Project_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.name}?`)
};

export const project_done = /** @type {(inputs: Project_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All done`)
};

export const project_finished = /** @type {(inputs: Project_FinishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: all done!`)
};

export const project_intro = /** @type {(inputs: Project_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split it into bite-size steps. They come up one at a time between your regular chores.`)
};

export const project_name = /** @type {(inputs: Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the job?`)
};

export const project_new = /** @type {(inputs: Project_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New big job`)
};

export const project_new_sub = /** @type {(inputs: Project_New_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear out the garage, bit by bit`)
};

export const project_pace = /** @type {(inputs: Project_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How fast`)
};

export const project_pace_1 = /** @type {(inputs: Project_Pace_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A step a day`)
};

export const project_pace_3 = /** @type {(inputs: Project_Pace_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every few days`)
};

export const project_pace_7 = /** @type {(inputs: Project_Pace_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A step a week`)
};

export const project_placeholder = /** @type {(inputs: Project_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear out the garage`)
};

export const project_progress = /** @type {(inputs: Project_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ${i?.done} of ${i?.total} steps done`)
};

export const project_row_sub = /** @type {(inputs: Project_Row_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.total} steps done`)
};

export const project_step_of = /** @type {(inputs: Project_Step_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.project} · step ${i?.step} of ${i?.total}`)
};

export const project_steps = /** @type {(inputs: Project_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steps, in order`)
};

export const project_steps_hint = /** @type {(inputs: Project_Steps_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About 15 minutes each works best.`)
};

export const push_blocked = /** @type {(inputs: Push_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are blocked in your browser settings.`)
};

export const push_blocked_here = /** @type {(inputs: Push_Blocked_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocked. Allow notifications for CleanReminder in your phone's settings.`)
};

export const push_daily_body_start = /** @type {(inputs: Push_Daily_Body_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About ${i?.minutes} minutes. A good day to start a streak.`)
};

export const push_daily_body_streak = /** @type {(inputs: Push_Daily_Body_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About ${i?.minutes} minutes. Keep your ${i?.streak}-day streak going.`)
};

export const push_daily_title = /** @type {(inputs: Push_Daily_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Today: ${i?.chore}`)
};

export const push_high_five_title = /** @type {(inputs: Push_High_Five_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} high-fived you`)
};

export const push_ios_first = /** @type {(inputs: Push_Ios_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On iPhone, add the app to your Home Screen first.`)
};

export const push_on = /** @type {(inputs: Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reminders are on`)
};

export const push_on_devices = /** @type {(inputs: Push_On_DevicesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`On for ${i?.count} device`);
	return /** @type {LocalizedString} */ (`On for ${i?.count} devices`)
	
};

export const push_recap_body = /** @type {(inputs: Push_Recap_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You did ${i?.mine} chores and the household did ${i?.total}. Open the app for the full recap.`)
};

export const push_recap_body_solo = /** @type {(inputs: Push_Recap_Body_SoloInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You did ${i?.mine} chores this week. Open the app for the full recap.`)
};

export const push_recap_title = /** @type {(inputs: Push_Recap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your week in the house`)
};

export const push_streak_body = /** @type {(inputs: Push_Streak_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten minutes and it stays alive.`)
};

export const push_streak_body_freezes = /** @type {(inputs: Push_Streak_Body_FreezesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`You have ${i?.count} streak freeze left, but ten minutes keeps it safe.`);
	return /** @type {LocalizedString} */ (`You have ${i?.count} streak freezes left, but ten minutes keeps it safe.`)
	
};

export const push_streak_title = /** @type {(inputs: Push_Streak_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your ${i?.streak}-day streak ends tonight`)
};

export const push_team_body = /** @type {(inputs: Push_Team_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chore}, +${i?.xp} XP`)
};

export const push_team_body_level = /** @type {(inputs: Push_Team_Body_LevelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chore}, +${i?.xp} XP, and reached level ${i?.level}`)
};

export const push_team_title = /** @type {(inputs: Push_Team_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} finished a chore`)
};

export const push_test_body = /** @type {(inputs: Push_Test_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is what your daily reminder will look like.`)
};

export const push_test_title = /** @type {(inputs: Push_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are on`)
};

export const push_timer_dishwasher_body = /** @type {(inputs: Push_Timer_Dishwasher_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean dishes, ready to put away.`)
};

export const push_timer_dishwasher_title = /** @type {(inputs: Push_Timer_Dishwasher_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The dishwasher is done`)
};

export const push_timer_dryer_body = /** @type {(inputs: Push_Timer_Dryer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fold it while it's warm: fewer creases.`)
};

export const push_timer_dryer_title = /** @type {(inputs: Push_Timer_Dryer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The dryer is done`)
};

export const push_timer_other_body = /** @type {(inputs: Push_Timer_Other_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time's up.`)
};

export const push_timer_other_title = /** @type {(inputs: Push_Timer_Other_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your timer is done`)
};

export const push_timer_oven_body = /** @type {(inputs: Push_Timer_Oven_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take a look before it burns.`)
};

export const push_timer_oven_title = /** @type {(inputs: Push_Timer_Oven_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The oven timer is done`)
};

export const push_timer_washer_body = /** @type {(inputs: Push_Timer_Washer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time to hang up the laundry before it gets musty.`)
};

export const push_timer_washer_title = /** @type {(inputs: Push_Timer_Washer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The washing machine is done`)
};

export const push_trade_accepted = /** @type {(inputs: Push_Trade_AcceptedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} took the trade`)
};

export const push_trade_accepted_body = /** @type {(inputs: Push_Trade_Accepted_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your chore today: ${i?.chore}`)
};

export const push_trade_body = /** @type {(inputs: Push_Trade_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Their ${i?.give} for your ${i?.get}`)
};

export const push_trade_declined = /** @type {(inputs: Push_Trade_DeclinedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} kept their chore`)
};

export const push_trade_declined_body = /** @type {(inputs: Push_Trade_Declined_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You still have: ${i?.chore}`)
};

export const push_trade_title = /** @type {(inputs: Push_Trade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} wants to trade chores`)
};

export const push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser doesn't support notifications.`)
};

export const push_unsupported_here = /** @type {(inputs: Push_Unsupported_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser can't show notifications`)
};

export const q_bathrooms = /** @type {(inputs: Q_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many bathrooms?`)
};

export const q_home_type = /** @type {(inputs: Q_Home_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What kind of home?`)
};

export const q_pets = /** @type {(inputs: Q_PetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any pets?`)
};

export const q_spaces = /** @type {(inputs: Q_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which of these do you have?`)
};

export const q_things = /** @type {(inputs: Q_ThingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's in your home?`)
};

export const q_toilet = /** @type {(inputs: Q_ToiletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where's the toilet?`)
};

export const rarity_common = /** @type {(inputs: Rarity_CommonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common`)
};

export const rarity_epic = /** @type {(inputs: Rarity_EpicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic`)
};

export const rarity_legendary = /** @type {(inputs: Rarity_LegendaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendary`)
};

export const rarity_rare = /** @type {(inputs: Rarity_RareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rare`)
};

export const rebalance = /** @type {(inputs: RebalanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebalance`)
};

export const rebalance_confirm_title = /** @type {(inputs: Rebalance_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebalance the chore list?`)
};

export const rebalance_sub = /** @type {(inputs: Rebalance_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Switch starter chores on or off to fit ${i?.people}. Your own chores stay as they are.`)
};

export const rebalance_title = /** @type {(inputs: Rebalance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebalance chore list`)
};

export const recap_household_chores = /** @type {(inputs: Recap_Household_ChoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Household`)
};

export const recap_row = /** @type {(inputs: Recap_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} chores this week, ${i?.mine} by you`)
};

export const recap_row_solo = /** @type {(inputs: Recap_Row_SoloInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.mine} chores this week`)
};

export const recap_subtitle = /** @type {(inputs: Recap_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The last 7 days, compared with the week before.`)
};

export const recap_title = /** @type {(inputs: Recap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your week`)
};

export const recap_top = /** @type {(inputs: Recap_TopInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.name} did the most: ${i?.count} chore`);
	return /** @type {LocalizedString} */ (`${i?.name} did the most: ${i?.count} chores`)
	
};

export const recap_your_chores = /** @type {(inputs: Recap_Your_ChoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your chores`)
};

export const reload = /** @type {(inputs: ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload`)
};

export const remind_me_at = /** @type {(inputs: Remind_Me_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remind me at`)
};

export const reminder_body = /** @type {(inputs: Reminder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a notification with your chore each day.`)
};

export const reminder_cta = /** @type {(inputs: Reminder_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a daily reminder`)
};

export const reminder_cta_sub = /** @type {(inputs: Reminder_Cta_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A notification with your chore each day`)
};

export const reminder_set = /** @type {(inputs: Reminder_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reminder set for ${i?.time}`)
};

export const reminder_title = /** @type {(inputs: Reminder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily reminder`)
};

export const reminders = /** @type {(inputs: RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reminders`)
};

export const remove = /** @type {(inputs: RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const repeats = /** @type {(inputs: RepeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeats`)
};

export const rescue_bonus = /** @type {(inputs: Rescue_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rescue bonus`)
};

export const rest_day_body = /** @type {(inputs: Rest_Day_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No chore today, and your streak stays safe. Enjoy it.`)
};

export const rest_day_title = /** @type {(inputs: Rest_Day_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest day`)
};

export const review_chores = /** @type {(inputs: Review_ChoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review chores first`)
};

export const rhythm_change = /** @type {(inputs: Rhythm_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change it`)
};

export const rhythm_changed = /** @type {(inputs: Rhythm_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chore} is now ${i?.freq}`)
};

export const rhythm_early = /** @type {(inputs: Rhythm_EarlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chore} usually gets done before it's due.`)
};

export const rhythm_keep = /** @type {(inputs: Rhythm_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep as is`)
};

export const rhythm_label = /** @type {(inputs: Rhythm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rhythm tip`)
};

export const rhythm_late = /** @type {(inputs: Rhythm_LateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chore} usually gets done a good while after it's due.`)
};

export const rhythm_question = /** @type {(inputs: Rhythm_QuestionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.new} instead of ${i?.old}?`)
};

export const rhythm_skipped = /** @type {(inputs: Rhythm_SkippedInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.chore} got skipped once lately.`);
	return /** @type {LocalizedString} */ (`${i?.chore} got skipped ${i?.count} times lately.`)
	
};

export const room = /** @type {(inputs: RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Room`)
};

export const room_bathroom = /** @type {(inputs: Room_BathroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bathroom`)
};

export const room_bathroom_2 = /** @type {(inputs: Room_Bathroom_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bathroom 2`)
};

export const room_bathroom_3 = /** @type {(inputs: Room_Bathroom_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bathroom 3`)
};

export const room_bedroom = /** @type {(inputs: Room_BedroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedroom`)
};

export const room_buy_body = /** @type {(inputs: Room_Buy_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} coins. It goes straight into ${i?.pet}'s room.`)
};

export const room_dining_room = /** @type {(inputs: Room_Dining_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dining area`)
};

export const room_garage = /** @type {(inputs: Room_GarageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garage`)
};

export const room_guest_room = /** @type {(inputs: Room_Guest_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest room`)
};

export const room_hallway = /** @type {(inputs: Room_HallwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallway and stairs`)
};

export const room_intro = /** @type {(inputs: Room_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save up for furniture. One thing per spot; tap something you own to put it away or back.`)
};

export const room_kitchen = /** @type {(inputs: Room_KitchenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kitchen`)
};

export const room_laundry_room = /** @type {(inputs: Room_Laundry_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laundry room`)
};

export const room_living_room = /** @type {(inputs: Room_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Living room`)
};

export const room_name = /** @type {(inputs: Room_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Room name`)
};

export const room_office = /** @type {(inputs: Room_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home office`)
};

export const room_outdoors = /** @type {(inputs: Room_OutdoorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outdoors`)
};

export const room_pets = /** @type {(inputs: Room_PetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pets`)
};

export const room_placed = /** @type {(inputs: Room_PlacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the room`)
};

export const room_placeholder = /** @type {(inputs: Room_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office`)
};

export const room_row_sub = /** @type {(inputs: Room_Row_SubInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`1 piece of furniture`);
	return /** @type {LocalizedString} */ (`${i?.count} pieces of furniture`)
	
};

export const room_tap_to_place = /** @type {(inputs: Room_Tap_To_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to place`)
};

export const room_title = /** @type {(inputs: Room_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pet}'s room`)
};

export const room_toilet = /** @type {(inputs: Room_ToiletInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toilet`)
};

export const room_whole_house = /** @type {(inputs: Room_Whole_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whole house`)
};

export const save = /** @type {(inputs: SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

export const save_date = /** @type {(inputs: Save_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

export const saved = /** @type {(inputs: SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

export const schedule_hint = /** @type {(inputs: Schedule_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap a day to switch between 1 chore, 2 chores and a rest day. Rest days never break your streak.`)
};

export const schedule_saved = /** @type {(inputs: Schedule_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week saved`)
};

export const seasonal = /** @type {(inputs: SeasonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seasonal`)
};

export const seasonal_sub = /** @type {(inputs: Seasonal_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only suggest in certain months`)
};

export const sections = /** @type {(inputs: SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections`)
};

export const see_all = /** @type {(inputs: See_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`See all ${i?.count}`)
};

export const select_all_that_apply = /** @type {(inputs: Select_All_That_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick all that apply`)
};

export const settings = /** @type {(inputs: SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

export const setup_body = /** @type {(inputs: Setup_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`For a household of ${i?.people}, ${i?.active} chores are switched on. That's about ${i?.perDay} a day to share. ${i?.more} more are there to switch on whenever you like.`)
};

export const setup_body_solo = /** @type {(inputs: Setup_Body_SoloInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`For just you, ${i?.active} chores are switched on. That's about ${i?.perDay} a day. ${i?.more} more are there to switch on whenever you like.`)
};

export const setup_title = /** @type {(inputs: Setup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your chore list is ready`)
};

export const share_invite = /** @type {(inputs: Share_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share invite`)
};

export const shop_intro = /** @type {(inputs: Shop_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every chore earns coins. Dress ${i?.pet} up, one thing per spot.`)
};

export const shop_outfits = /** @type {(inputs: Shop_OutfitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outfits`)
};

export const shop_owned = /** @type {(inputs: Shop_OwnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to wear`)
};

export const shop_row_sub = /** @type {(inputs: Shop_Row_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outfits and streak freezes`)
};

export const shop_title = /** @type {(inputs: Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Companion shop`)
};

export const shop_to_go = /** @type {(inputs: Shop_To_GoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} to go`)
};

export const shop_wearing = /** @type {(inputs: Shop_WearingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wearing`)
};

export const show_earned = /** @type {(inputs: Show_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show earned`)
};

export const show_inactive = /** @type {(inputs: Show_InactiveInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Show ${i?.count} switched-off chore`);
	return /** @type {LocalizedString} */ (`Show ${i?.count} switched-off chores`)
	
};

export const show_more = /** @type {(inputs: Show_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show more`)
};

export const sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

export const sign_out_device = /** @type {(inputs: Sign_Out_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out this device`)
};

export const sign_out_here = /** @type {(inputs: Sign_Out_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out on this device`)
};

export const signed_in = /** @type {(inputs: Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in`)
};

export const slip_body = /** @type {(inputs: Slip_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} has earned it and may now go and get:`)
};

export const slip_ok = /** @type {(inputs: Slip_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy!`)
};

export const slip_signed = /** @type {(inputs: Slip_SignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Signed, ${i?.pet}`)
};

export const slip_title = /** @type {(inputs: Slip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission slip`)
};

export const someone = /** @type {(inputs: SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Someone`)
};

export const start_break = /** @type {(inputs: Start_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start break`)
};

export const stat_chores = /** @type {(inputs: Stat_ChoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chores`)
};

export const stat_freezes = /** @type {(inputs: Stat_FreezesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freezes`)
};

export const stat_streak = /** @type {(inputs: Stat_StreakInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Streak · best ${i?.best}`)
};

export const step_add = /** @type {(inputs: Step_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a step`)
};

export const step_delete = /** @type {(inputs: Step_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.name}`)
};

export const step_done_by = /** @type {(inputs: Step_Done_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Done by ${i?.name}`)
};

export const step_n = /** @type {(inputs: Step_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Step ${i?.n}`)
};

export const step_of = /** @type {(inputs: Step_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Step ${i?.step} of ${i?.total}`)
};

export const step_placeholder = /** @type {(inputs: Step_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort the shelves`)
};

export const step_remove = /** @type {(inputs: Step_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove step ${i?.n}`)
};

export const step_up_next = /** @type {(inputs: Step_Up_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Up next · ${i?.minutes} min`)
};

export const sticker_bird = /** @type {(inputs: Sticker_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early Bird`)
};

export const sticker_bucket = /** @type {(inputs: Sticker_BucketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trusty Bucket`)
};

export const sticker_cat = /** @type {(inputs: Sticker_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supervisor Cat`)
};

export const sticker_crown = /** @type {(inputs: Sticker_CrownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crown of Tidiness`)
};

export const sticker_fish = /** @type {(inputs: Sticker_FishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidy Tank`)
};

export const sticker_flower = /** @type {(inputs: Sticker_FlowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fresh Flowers`)
};

export const sticker_label = /** @type {(inputs: Sticker_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rarity} sticker`)
};

export const sticker_lamp = /** @type {(inputs: Sticker_LampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cozy Lamp`)
};

export const sticker_lemon = /** @type {(inputs: Sticker_LemonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lemon Fresh`)
};

export const sticker_plant = /** @type {(inputs: Sticker_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Happy Plant`)
};

export const sticker_rainbow = /** @type {(inputs: Sticker_RainbowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streak-Free Rainbow`)
};

export const sticker_robot = /** @type {(inputs: Sticker_RobotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robo Vacuum`)
};

export const sticker_shirt = /** @type {(inputs: Sticker_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fresh Laundry`)
};

export const sticker_soap = /** @type {(inputs: Sticker_SoapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hand Soap`)
};

export const sticker_sparkles = /** @type {(inputs: Sticker_SparklesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sparkles`)
};

export const sticker_sponge = /** @type {(inputs: Sticker_SpongeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bubble Bath`)
};

export const sticker_spray = /** @type {(inputs: Sticker_SprayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spray Bottle`)
};

export const sticker_tea = /** @type {(inputs: Sticker_TeaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Well-Earned Tea`)
};

export const sticker_wand = /** @type {(inputs: Sticker_WandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magic Wand`)
};

export const sticker_washer = /** @type {(inputs: Sticker_WasherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spin Cycle`)
};

export const stickers = /** @type {(inputs: StickersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stickers`)
};

export const stickers_found = /** @type {(inputs: Stickers_FoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.owned} of ${i?.total} found`)
};

export const stickers_hint = /** @type {(inputs: Stickers_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finished chores sometimes drop a sticker, and bonus chores drop them more often.`)
};

export const streak_days = /** @type {(inputs: Streak_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}-day streak`);
	return /** @type {LocalizedString} */ (`${i?.count}-day streak`)
	
};

export const supplies = /** @type {(inputs: SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supplies`)
};

export const supplies_add = /** @type {(inputs: Supplies_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

export const supplies_added_by = /** @type {(inputs: Supplies_Added_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Added by ${i?.name}`)
};

export const supplies_bought = /** @type {(inputs: Supplies_BoughtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bought`)
};

export const supplies_clear = /** @type {(inputs: Supplies_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

export const supplies_empty = /** @type {(inputs: Supplies_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing on the list. Add what's running low.`)
};

export const supplies_placeholder = /** @type {(inputs: Supplies_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dish soap, bin bags…`)
};

export const supplies_sub = /** @type {(inputs: Supplies_SubInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} thing to buy`);
	return /** @type {LocalizedString} */ (`${i?.count} things to buy`)
	
};

export const supplies_sub_empty = /** @type {(inputs: Supplies_Sub_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running low on something?`)
};

export const swap = /** @type {(inputs: SwapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap`)
};

export const swapped = /** @type {(inputs: SwappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swapped`)
};

export const switched_off_body = /** @type {(inputs: Switched_Off_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These are never picked. Switch one on and it joins the rotation.`)
};

export const switched_off_empty = /** @type {(inputs: Switched_Off_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything is switched on.`)
};

export const switched_off_title = /** @type {(inputs: Switched_Off_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switched-off chores`)
};

export const tab_chores = /** @type {(inputs: Tab_ChoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chores`)
};

export const tab_house = /** @type {(inputs: Tab_HouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House`)
};

export const tab_profile = /** @type {(inputs: Tab_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

export const tab_today = /** @type {(inputs: Tab_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

export const take_bonus = /** @type {(inputs: Take_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take on a bonus chore`)
};

export const take_break = /** @type {(inputs: Take_BreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take a break`)
};

export const take_break_sub = /** @type {(inputs: Take_Break_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacation or sick: no chores, streak kept`)
};

export const takes_about = /** @type {(inputs: Takes_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takes about`)
};

export const tap_to_continue = /** @type {(inputs: Tap_To_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to continue`)
};

export const test = /** @type {(inputs: TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

export const test_none = /** @type {(inputs: Test_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No devices reached. Try turning notifications on again.`)
};

export const test_sent = /** @type {(inputs: Test_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test notification sent`)
};

export const this_device = /** @type {(inputs: This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(this device)`)
};

export const timer = /** @type {(inputs: TimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer`)
};

export const timer_clear = /** @type {(inputs: Timer_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emptied`)
};

export const timer_done_at = /** @type {(inputs: Timer_Done_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Done at ${i?.time}`)
};

export const timer_finished_at = /** @type {(inputs: Timer_Finished_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Finished at ${i?.time}`)
};

export const timer_go = /** @type {(inputs: Timer_GoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} minutes. Go.`)
};

export const timer_how_long = /** @type {(inputs: Timer_How_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long`)
};

export const timer_intro = /** @type {(inputs: Timer_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone at home sees it, and you get a notification when it's done.`)
};

export const timer_intro_no_push = /** @type {(inputs: Timer_Intro_No_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone at home sees it. Turn on notifications in Settings to get a ping when it's done.`)
};

export const timer_kind_dishwasher = /** @type {(inputs: Timer_Kind_DishwasherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dishwasher`)
};

export const timer_kind_dryer = /** @type {(inputs: Timer_Kind_DryerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dryer`)
};

export const timer_kind_other = /** @type {(inputs: Timer_Kind_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something else`)
};

export const timer_kind_oven = /** @type {(inputs: Timer_Kind_OvenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oven`)
};

export const timer_kind_washer = /** @type {(inputs: Timer_Kind_WasherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washing machine`)
};

export const timer_machine = /** @type {(inputs: Timer_MachineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine`)
};

export const timer_minutes = /** @type {(inputs: Timer_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutes`)
};

export const timer_new = /** @type {(inputs: Timer_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laundry timer`)
};

export const timer_new_sub = /** @type {(inputs: Timer_New_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washing machine, dryer, dishwasher: a ping when it's done`)
};

export const timer_pause = /** @type {(inputs: Timer_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

export const timer_restart = /** @type {(inputs: Timer_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restart`)
};

export const timer_resume = /** @type {(inputs: Timer_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

export const timer_start = /** @type {(inputs: Timer_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

export const timer_start_at = /** @type {(inputs: Timer_Start_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start · done at ${i?.time}`)
};

export const timer_stop = /** @type {(inputs: Timer_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop timer`)
};

export const timers_title = /** @type {(inputs: Timers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machines`)
};

export const times_up = /** @type {(inputs: Times_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time's up.`)
};

export const today = /** @type {(inputs: TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

export const toilet_in_bathroom = /** @type {(inputs: Toilet_In_BathroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the bathroom`)
};

export const toilet_separate = /** @type {(inputs: Toilet_SeparateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separate room`)
};

export const trade = /** @type {(inputs: TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trade`)
};

export const trade_accept = /** @type {(inputs: Trade_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trade`)
};

export const trade_ask = /** @type {(inputs: Trade_AskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ask ${i?.name}`)
};

export const trade_decline = /** @type {(inputs: Trade_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No thanks`)
};

export const trade_done = /** @type {(inputs: Trade_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traded! Enjoy your new chore.`)
};

export const trade_incoming = /** @type {(inputs: Trade_IncomingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} wants to trade`)
};

export const trade_sent = /** @type {(inputs: Trade_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Asked ${i?.name}`)
};

export const trade_theirs = /** @type {(inputs: Trade_TheirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theirs`)
};

export const trade_title = /** @type {(inputs: Trade_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trade with ${i?.name}?`)
};

export const trade_waiting = /** @type {(inputs: Trade_WaitingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting for ${i?.name}`)
};

export const trade_you_get = /** @type {(inputs: Trade_You_GetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You get`)
};

export const trade_you_give = /** @type {(inputs: Trade_You_GiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You give`)
};

export const trade_yours = /** @type {(inputs: Trade_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yours`)
};

export const treat_add = /** @type {(inputs: Treat_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add treat`)
};

export const treat_name_label = /** @type {(inputs: Treat_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treat`)
};

export const treat_name_placeholder = /** @type {(inputs: Treat_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New plant`)
};

export const treat_price_label = /** @type {(inputs: Treat_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coins`)
};

export const treat_redeem = /** @type {(inputs: Treat_RedeemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treat yourself`)
};

export const treats_earned = /** @type {(inputs: Treats_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earned`)
};

export const treats_empty = /** @type {(inputs: Treats_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No treats yet. What would you like to earn?`)
};

export const treats_intro = /** @type {(inputs: Treats_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Things you'd like to earn, paid for with coins. When you can afford one, you get a permission slip.`)
};

export const treats_row_sub = /** @type {(inputs: Treats_Row_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real-life rewards for your coins`)
};

export const treats_title = /** @type {(inputs: Treats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treats`)
};

export const try_again = /** @type {(inputs: Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

export const turn_on = /** @type {(inputs: Turn_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on`)
};

export const turn_on_reminders = /** @type {(inputs: Turn_On_RemindersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on reminders`)
};

export const tz_note = /** @type {(inputs: Tz_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reminders use ${i?.tz}.`)
};

export const tz_switch = /** @type {(inputs: Tz_SwitchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Switch to ${i?.tz}`)
};

export const verdict_balanced = /** @type {(inputs: Verdict_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balanced`)
};

export const verdict_tight = /** @type {(inputs: Verdict_TightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tight`)
};

export const verdict_too_much = /** @type {(inputs: Verdict_Too_MuchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too much`)
};

export const weather = /** @type {(inputs: WeatherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weather`)
};

export const weather_intro = /** @type {(inputs: Weather_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows, the balcony and the garden are saved for a dry day. The forecast comes from Open-Meteo, and only your town is used.`)
};

export const weather_none = /** @type {(inputs: Weather_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No places found.`)
};

export const weather_remove = /** @type {(inputs: Weather_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't use the weather`)
};

export const weather_search = /** @type {(inputs: Weather_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Town or city`)
};

export const weather_sub_off = /** @type {(inputs: Weather_Sub_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save outdoor chores for dry days`)
};

export const weather_sub_on = /** @type {(inputs: Weather_Sub_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.place}: outdoor chores on dry days`)
};

export const weather_title = /** @type {(inputs: Weather_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where do you live?`)
};

export const welcome_create = /** @type {(inputs: Welcome_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a household`)
};

export const welcome_join = /** @type {(inputs: Welcome_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join with an invite code`)
};

export const welcome_link = /** @type {(inputs: Welcome_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with a device code`)
};

export const who_does_it = /** @type {(inputs: Who_Does_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who does it`)
};

export const who_does_it_hint = /** @type {(inputs: Who_Does_It_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick someone to make this their chore. They'll be the only one who gets it.`)
};

export const xp_until_grows = /** @type {(inputs: Xp_Until_GrowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.xp} / ${i?.next} XP until ${i?.name} grows`)
};

export const yay = /** @type {(inputs: YayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yay!`)
};

export const year_days = /** @type {(inputs: Year_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`on ${i?.count} day`);
	return /** @type {LocalizedString} */ (`on ${i?.count} different days`)
	
};

export const year_empty = /** @type {(inputs: Year_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No chores yet this year. The story starts with your first one!`)
};

export const year_end = /** @type {(inputs: Year_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here's to next year`)
};

export const year_fav = /** @type {(inputs: Year_FavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your signature move`)
};

export const year_high_fives = /** @type {(inputs: Year_High_FivesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`high-fives from housemates`)
};

export const year_intro = /** @type {(inputs: Year_IntroInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.year}, in chores`)
};

export const year_intro_sub = /** @type {(inputs: Year_Intro_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to see how it went`)
};

export const year_month = /** @type {(inputs: Year_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Busiest month: ${i?.month}`)
};

export const year_pet = /** @type {(inputs: Year_PetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pet} grew into a ${i?.stage}`)
};

export const year_room = /** @type {(inputs: Year_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your room`)
};

export const year_row = /** @type {(inputs: Year_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your ${i?.year}`)
};

export const year_row_sub = /** @type {(inputs: Year_Row_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your year in chores`)
};

export const year_run = /** @type {(inputs: Year_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`days in a row`)
};

export const year_run_sub = /** @type {(inputs: Year_Run_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your longest run`)
};

export const year_share = /** @type {(inputs: Year_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`of everything done at home`)
};

export const year_times = /** @type {(inputs: Year_TimesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} time`);
	return /** @type {LocalizedString} */ (`${i?.count} times`)
	
};

export const year_total = /** @type {(inputs: Year_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chores done`)
};

export const yesterday = /** @type {(inputs: YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yesterday`)
};

export const you = /** @type {(inputs: YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You`)
};

export const you_suffix = /** @type {(inputs: You_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(you)`)
};

export const your_colour = /** @type {(inputs: Your_ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your colour`)
};

export const your_companion = /** @type {(inputs: Your_CompanionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your companion`)
};

export const your_devices = /** @type {(inputs: Your_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your devices`)
};

export const your_home = /** @type {(inputs: Your_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your home`)
};

export const your_home_sub = /** @type {(inputs: Your_Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rooms, pets and appliances`)
};

export const your_home_unset = /** @type {(inputs: Your_Home_UnsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer a few questions for a better list`)
};

export const your_name = /** @type {(inputs: Your_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your name`)
};

export const your_week = /** @type {(inputs: Your_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your week`)
};